import React, { useState, useEffect, useRef} from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { MdKeyboardArrowDown,MdKeyboardArrowUp,MdKeyboardArrowRight,MdArrowLeft,MdArrowRight } from 'react-icons/md'
import { IoSearch } from 'react-icons/io5'
import { HiStar } from 'react-icons/hi'
import { FaArrowUp,FaArrowDown } from 'react-icons/fa6'
import { IoTicketOutline,IoCloseOutline} from 'react-icons/io5'
import { MdModeEdit } from 'react-icons/md'
import { CiCalendarDate } from 'react-icons/ci'
import { ImBin2 } from 'react-icons/im'
import { GiCheckMark } from 'react-icons/gi'
import { LuMail } from 'react-icons/lu'
import { MdOutlineAutorenew } from 'react-icons/md'
import RegressionImg from '../../util/img/regression.svg'
import styled from 'styled-components'
import './style.css'
import axios from 'axios'
import * as d3 from 'd3'
const APIURL1=process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV1}` : `${process.env.REACT_APP_DB_ENV_TEST1}`
const StyledContainer=styled.div`
  padding: 0 6px;
  font-size: 12px;
`
const currency=(_id) => {return "US$"}
const HoverLabel=({active,payload,_id,label}) => {
    if (active && payload && payload.length) {
        return (<div className="hover-label">{`${label} ${currency(_id)}${payload[0].payload.price!='undefiined'?payload[0].payload.price:''}`}</div>)
    }
    return null
}
export default function LinearGenerator({yCurUpdate2}) {
    const graph_term=[{term:'pred'},{term:'3M'},{term:'6M'},{term:'1Y'},{term:'3Y'},{term:'6Y'},{term:'10Y'}]
    const [market, setMarket] = useState([{name:'nsdq','data':[]},{name:'nyse','data':[]}])
    const [default_stock_info, setDefault_stock_info]=useState([{"symbol": "NVDA","name": "NVIDIA Corporation","industry": "tech","items3M": [{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 }]},{"symbol": "AMZN","name": "Amazon.com, Inc.","industry": "e-commerce","items3M": [{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 }]},{"symbol": "GOOGL","name": "Alphabet Inc.","industry": "tech","items3M": [{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 },{ name: '', value: 0 }]}])
    const [searchSymbolTxt, setSearchSymbolTxt] = useState('')
    const [searchSymbolResult, setSearchSymbolResult] = useState(default_stock_info)
    const [filterIndustry, setFilterIndustry]=useState(default_stock_info)
    const [industryList2, setIndustryList2]=useState()
    const [stock_graph1, setStock_graph1]=useState()
    const [selectedIndustry, setSelectedIndustry]=useState('')
    const [selectedStock1, setSelectedStock1]=useState()
    const [selectedStocki1, setSelectedStocki1]=useState(1)//5
    const [selectedMarket,setSelectedMarket]=useState('nsdq')
    const [selectedTerm, setSelectedTerm]=useState('pred')
    const [selectedLimit, setSelectedLimit]=useState('catg 10')
    const [selectMenu1, setSelectMenu1]=useState(false)
    const [selectMenu2, setSelectMenu2]=useState(false)
    const [selectMenu3,setSelectMenu3]=useState(true)
    const [selectMenu4,setSelectMenu4]=useState(false)
    const [selectMenu5,setSelectMenu5]=useState(false)
    const [selectMenu6,setSelectMenu6]=useState(false)
    const [page,setPage]=useState('mainpage')
    const [toolTip,setToolTip]=useState(false)
    const [loading, setLoading] = useState(false)
    const [loadingPrice, setLoadingPrice] = useState(false)
    const [loadingTime, setLoadingTime] = useState('')
    const [loadingMsg, setLoadingMsg]= useState(true)
    const [notificationEdit,setNotificationEdit]=useState(false)
    const [amount1,setAmount1]=useState(10000)
    const [amount2,setAmount2]=useState(1000)
    const [term,setTerm]=useState(0)
    const account_token = localStorage.getItem('account_token')
    const [account, setAccount] = useState({username:'',email:'', pwd:''})
    const [stockAccount2,setStockAccount2]=useState({username:'DonJoe123',pwd:'123',email:'jon.doe@gmail.com',subscribe:'true',amount:1000,st:'2026-01-01',end:'2026-03-01',min:-90,max:150,symbol:'AAPL',curr_price:120,notification_history:[{date:'01.31.2024',return:150},{date:'05.20.2024 ',return:50},{date:'08.02.2024 ',return:-90}]})
    const [prevType,setPrevType]=useState('net income')
    const [type,setType]=useState('net income')
    const [msg, setMsg] =useState('')
    const [st,setSt]=useState({date:'2026-01-05',price:100})//01/01/2022
    const [end,setEnd]=useState({date:'2026-01-20',price:110})//03/31/2023
    const [c_list3, setc_list3] = useState(c_list2())
    const [c_dsp, setc_dsp] = useState(c_list3.findIndex(x=>x.y==st.date.slice(0,4)&&x.m==st.date.slice(5,7))-1)
    const [yCurUpdate1, setYCurUpdate1] = useState(0)
    const [runtime, setRuntime] = useState(0)
    const w_list = ['Sun','Mon','Tue','Wed','Thu','Fri', 'Sat']
    useEffect(() => {
        getStock('nsdq')
    },[])
    const getStock=async(market1)=>{
        const st=Date.now()
        try{
            let data1=[]
            let sample1=35
            if (!loading){
                const {data:res}=await axios.get(`${APIURL1}/stock/stock_data`)
                if (typeof(res)=='string'){
                    data1=JSON.parse(res.replaceAll('NaN', 0).replaceAll(/\//g, '')).nsdq
                    setMarket([{name:'nsdq',data:JSON.parse(res.replaceAll('NaN', 0).replaceAll(/\//g, '')).nsdq},{name:'nyse',data:JSON.parse(res.replaceAll('NaN', 0).replaceAll(/\//g, '')).nyse}])
                    console.log('nyse:',JSON.parse(res.replaceAll('NaN', 0).replaceAll(/\//g, '')).nyse)
                    setLoadingTime(JSON.parse(res.replaceAll('NaN', 0).replaceAll(/\//g, '')).loading_time)
                }else{
                    data1=res.nsdq
                    setMarket([{name:'nsdq',data:res.nsdq},{name:'nyse',data:res.nyse}])
                    setLoadingTime(res.loading_time)
                }
                setLoading(true)
            }else{
                data1=market[market.findIndex((x)=>x.name==market1)]['data']
            }
            if(market1=='nsdq'){
                sample1=3
            }
            var pred=['m6_pred','m4_pred','m2_pred','m0_pred','-m2_pred','-m4_pred','-m6_pred']
            var pred2=['m6','m4','m2','m0','-m2_pred','-m4_pred','-m6_pred']
            var M3=['m3','m2_5','m2','m1_5','m1','m0_5','m0']
            var M6=['m6','m5','m4','m3','m2','m1','m0']
            var Y1=['y1','m10','m8','m6','m4','m2','m0']
            var Y3=['y3','y2_5','y2','y1_5','y1','m6','m0']
            var Y6=['y6','y5','y4','y3','y2','y1','m0']
            var Y10=['y10','y8','y6','y5','y4','y2','m0']
            var box=['-6m','-5m','-4m','-3m','-2m','-1m','td','m1','m2','m3','m4','m5','m6','m7','m8','m9','m10','m11','y1','y1m1','y1m2','y1m3','y1m4','y1m5','1.5y','y1m7','y1m8','y1m9','y1m10','y1m11','y2','y2m1','y2m2','y2m3','y2m4','y2m5','2.5y','y2m6','y2m7','y2m8','y2m9','y2m10','y2m11','y3','y3m1','y3m2','y3m3','y3m4','y3m5','3.5y','y3m6','y3m7','y3m8','y3m9','y3m10','y3m11','y4','y4m1','y4m2','y4m3','y4m4','y4m5','y4m6','y4m7','y4m8','y4m9','y4m10','y4m11','y5','y5m1','y5m2','y5m3','y5m4','y5m5','y5ym6','y5m7','y5m8','y5m9','y5m10','y5m11','6y','6ym1','6ym2','6ym3','6ym4','6ym5','6.5y','6ym7','6ym8','6ym9','6ym10','6ym11','7y','7ym1','7ym2','7ym3','7ym4','7ym5','7.5y','7ym7','7ym8','7ym9','7ym10','7ym11','y8','y8m1','y8m2','y8m3','y8m4','y8m5','1.5y','y8m7','y8m8','y8m9','y8m10','y8m11','y9','y9m1','y9m2','y9m3','y9m4','y9m5','y9m6','y9m7','y9m8','y9m9','y9m10','y9m11','y10']
            function trim1(x1){
                var formatted=[]
                var year=[]
                for (let x in x1) {
                    var findYear=[...x1[x].name].slice(0, 4).join('')
                    if(!year.includes(findYear)){
                        formatted.push(x1[x])
                        year.push(findYear)
                    }else{
                        formatted.push({
                            ...x1[x],
                            name: x1[x].name.slice(5, 10)
                        })
                    }
                }
                return formatted
            }
            function trim2(x1){
                var formatted=[]
                var year=[]
                var mmdd=[]
                for (let x in x1) {
                    var findYear=[...x1[x].name].slice(0, 4).join('')
                    var mmddFormat=[...x1[x].name].slice(5, 10).join('')
                    if(!year.includes(findYear)){
                        formatted.push(x1[x])
                        year.push(findYear)
                    }else{
                        if(!mmdd.includes(mmddFormat)){
                            formatted.push(x1[x])
                        }else{
                            formatted.push({
                                ...x1[x],
                                name: mmddFormat
                            })
                            mmdd.push(mmddFormat)
                        }
                    }
                }
                return formatted
            }
            
            for(let i=0;i<data1.length;i++){   
                const x1=data1[i]['graph']
                data1[i]['items20']=x1
                data1[i]['itemspred']=trim1(x1.filter(function(x){if(pred.includes(x.itemterm)){return x}}))
                data1[i]['itemspred2']=trim1(x1.filter(function(x){if(pred2.includes(x.itemterm)){return x}}))
                data1[i]['items3M']=trim1(x1.filter(function(x){if(M3.includes(x.itemterm)){return x}}))
                data1[i]['items6M']=trim1(x1.filter(function(x){if(M6.includes(x.itemterm)){return x}}))
                data1[i]['items1Y']=trim1(x1.filter(function(x){if(Y1.includes(x.itemterm)){return x}}))
                data1[i]['items3Y']=trim2(x1.filter(function(x){if(Y3.includes(x.itemterm)){return x}}))
                data1[i]['items6Y']=trim1(x1.filter(function(x){if(Y6.includes(x.itemterm)){return x}}))
                data1[i]['items10Y']=trim1(x1.filter(function(x){if(Y10.includes(x.itemterm)){return x}}))
                data1[i]['itemsbox']=x1.filter(function(x){if(box.includes(x.itemterm)){return x}}).toSorted((a, b) => b._id - a._id)
            }
            function industryList1(x1){
                let map=new Map()
                x1.forEach(x2 => map.set(x2.industry, x2.industry))
                let x3=[...map.values()]
                let a6=[]
                for (let x4 of x3) {
                    const a3=x1.filter(x5=>x5.industry==x4).sort((a, b) => a.symbol.localeCompare(b.symbol))
                    a6.push({industry:x4,item:a3})
                }
                a6=a6.sort(function(a, b) {return b.item.length - a.item.length})    
                return a6
            }
            setIndustryList2(industryList1(data1))
            setDefault_stock_info(data1)
            setSearchSymbolResult(data1)
            setFilterIndustry(data1)
            setStock_graph1(data1)
            setSelectedStock1(data1[sample1])
            setSelectedStocki1(sample1)
            setSt({date:data1[sample1].items3M[0].name,price:data1[3].items3M[0].price})
            setEnd({date:data1[sample1].items10Y[6].name,price:data1[3].items10Y[6].price})
            setLoadingMsg(false)
        }catch(err){
            console.log(err)
        }
        const end=Date.now()
        setYCurUpdate1(yCurUpdate1+1)
        yCurUpdate2(yCurUpdate1.toString())
        setRuntime(`${(end-st)/1000}s`)
    }
    const onClick2ManualUpdate=async()=>{
        try{
        const { data: res } = await axios.get(`${APIURL1}/stock/json_update`)
        setMsg(res.info)
        console.log(res)
        }catch(err){
        console.log(err)
        }
    }
    const onClick2Market=(e, x) => {
        e.preventDefault()
        setSelectedMarket(x)
        getStock(x)
    }
    const onClick2Term=(e, ttl) => {
        e.preventDefault()
        setSelectedTerm(ttl)
    }
    const onChange2SearchSymbol = e => {
        setSearchSymbolTxt(e.target.value)
        const x1=e.target.value
        const x2=default_stock_info.filter(x=>x.symbol.toLowerCase().includes(x1.toLowerCase()))
        setSearchSymbolResult(x2)
    }
    const onClick2FilterIndustry=(x1) => {
        setSelectedIndustry(x1.industry)
        setFilterIndustry(x1.item)
        setSelectedStock1(x1.item[0])
        setSelectedStocki1(x1.item[0]._id)
        setSelectMenu1(!selectMenu1)
    }
    const onClick2Stock1=(x)=> {
        console.log(stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)])
        setSelectedStock1(stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)])
        setSelectedStocki1(stock_graph1.findIndex((x1)=>x1._id==x._id))
        setSt({date:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items3M[0].name,price:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items3M[0].price})
        setEnd({date:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items10Y[6].name,price:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items10Y[6].price})
        setSelectMenu1(!selectMenu1) 
    }
    const onClick2Stock2=(x)=> {
        setSelectedStock1(stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)])
        setSelectedStocki1(stock_graph1.findIndex((x1)=>x1._id==x._id))
        setSt({date:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items3M[0].name,price:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items3M[0].price})
        setEnd({date:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items10Y[6].name,price:stock_graph1[stock_graph1.findIndex((x1)=>x1._id==x._id)].items10Y[6].price})
        setSelectMenu2(!selectMenu2)
    }
    const onClick2Stock3=(x1)=>{
        setSelectedStock1(stock_graph1[stock_graph1.findIndex((x2)=>x2._id==x1._id)])
        setSelectedStocki1(stock_graph1.findIndex((x2)=>x2._id==x1._id))
    }
    const onClick2StockUp=()=> {
        if(filterIndustry.findIndex((x)=>x._id==selectedStock1._id)!=0){
            const prev_id=filterIndustry[filterIndustry.findIndex((x)=>x._id==selectedStock1._id)-1]._id
            const prev_i=stock_graph1.findIndex((x)=>x._id==prev_id)
            setSelectedStock1(stock_graph1[prev_i])
            setSt({date:stock_graph1[prev_i].items3M[0].name,price:stock_graph1[prev_i].items3M[0].price})
            setEnd({date:stock_graph1[stock_graph1[prev_i].items10Y.length-1].items10Y[6].name,price:stock_graph1[stock_graph1[prev_i].items10Y.length-1].items10Y[6].price})
            setSelectedStocki1(prev_i)
        }
    }
    const onClick2StockDown=()=> {
        if(filterIndustry.length-1!=filterIndustry.findIndex((x)=>x._id==selectedStock1._id)){
            const next_id=filterIndustry[filterIndustry.findIndex((x)=>x._id==selectedStock1._id)+1]._id
            const next_i=stock_graph1.findIndex((x)=>x._id==next_id)
            setSelectedStock1(stock_graph1[next_i])
            setSt({date:stock_graph1[next_i].items3M[0].name,price:stock_graph1[next_i].items3M[0].price})
            setEnd({date:stock_graph1[next_i].items10Y[stock_graph1[next_i].items10Y.length-1].name,price:stock_graph1[next_i].items10Y[stock_graph1[next_i].items10Y.length-1].price})
            setSelectedStocki1(next_i)
        }
    }
    const onClick2Type=(x)=> {
        setPrevType(type)
        setType(x)
        if(type!='return'){
            setTerm(0)
        }
    }
    function star(x){
        const a=[]
        for(let i=0;i<Number(x);i++){
            a.push(i)
        }
        return a
    }
    const onChange2Amount1=(e)=>{
        setAmount1(e.target.value)
    }
    const onChange2Amount2=(e)=>{
        setAmount2(e.target.value)
    }
    const onChange2AccountInfo = ({currentTarget:y}, x) => {
        var b1 = [...updateList]
        var b2 = updateList.filter((w) => w.id === x)[0]
        var i = updateList.indexOf(b2)
        setUpdateItem({...b2, [y.name]:y.value})
        b1[i] = {...b2, [y.name]:y.value}
        list3(b1)
    }
    const onChange2Term=({ currentTarget: input })=>{
        setTerm(input.value)
        // if(type!='return'){
        //     setType('return')
        // }
    }
    function convert_num1(x3){
        if(x3 && String(x3).includes('T')==true) {
            const x5=Number(x3.replace('T',''))*1000000000000
            return x5
        }
        if(x3 && String(x3).includes('B')==true){
            const x5=Number(x3.replace('B',''))*1000000000
            return x5
        }
        if(x3 && String(x3).includes('M')==true){
            const x5=Number(x3.replace('M',''))*1000000
            return x5
        }
        if(x3 && String(x3).includes('K')==true){
            const x5=Number(x3.replace('K',''))*1000
            return x5
        }
        return Number(x3)
    }
    function convert_num2(x4){
        if(x4 && String(x4).includes('T')==true) {
            const x5=Number(x4.replace('T',''))*1000000000000
            return x5
        }
        if(x4 && String(x4).includes('B')==true){
            const x5=Number(x4.replace('B',''))*1000000000
            return x5
        }
        if(x4 && String(x4).includes('M')==true){
            const x5=Number(x4.replace('M',''))*1000000
            return x5
        } 
        return x4
    }
    function convert_num3(x4){
        if(x4 && String(x4).length>12) {
            const x5=Number(x4)/1000000000000
            return x5.toFixed(2)+'T'
        }
        if(x4 && String(x4).length>9) {
            const x5=Number(x4)/1000000000
            return x5.toFixed(2)+'B'
        }
        if(x4 && String(x4).length>6) {
            const x5=Number(x4)/1000000
            return x5.toFixed(2)+'M'
        }
        if(x4 && String(x4).length>3) {
            const x5=Number(x4)/1000
            return x5.toFixed(2)+'K'
        }
        return x4.toFixed(2)
    }
    function reorder_return(a,x1){ //industry,item
        const x2=[]
        for(let i=0;i<x1.length;i++){
            if(stock_graph1[stock_graph1.findIndex((x)=>x._id==x1[i]._id)].itemsbox.map(x3=>
                x3.return
            )[term]!=undefined){
                let x3=convert_num1(x1[i].market_cap)
                let x4=0
                if(x3>1000000000000){
                    x4=120
                }else if(x3>1000000000){
                    x4=60
                }else {
                    x4=45
                }
                if(x1[i].symbol!='GOOG'){                   
                    x2.push({_id:x1[i]._id,name:x1[i].name,symbol:x1[i].symbol,return:stock_graph1[stock_graph1.findIndex((x)=>x._id==x1[i]._id)].itemsbox.map(x3=>x3.return)[term],employee:x1[i].employee,founded:x1[i].founded,market_cap:x1[i].market_cap,revenue:x1[i].revenue,net_income:x1[i].net_income,asset:x1[i].asset,equity:x1[i].equity,risk:x1[i].risk,prev:i+1,w:x4,value:x3})
                }
            }else{
                x2.push({'symbol':x1[i].symbol,'return':'0%'})
            }
        }
        if(type=='risk'){
            const x3=x2.filter(x =>x.risk?.length==5)
            const x4=x3.toSorted((a, b)=>convert_num1(b.market_cap)-convert_num1(a.market_cap))
            const x5=x4.toSorted((a, b) =>b.risk[4]['overall risk']-a.risk[4]['overall risk'])
            const x6=[]
            for(let i=0;i<x5.length;i++){
                x6.push({...x5[i],next:i+1})
            }
            return x6
        }else if(type=='employee'){
            const x7=x2.filter(x6=>x6.employee!='')
            const x8= x7.toSorted((a, b) =>Number(b.employee) -Number(a.employee))
            const x9=[]
            for(let i=0;i<x8.length;i++){
                x9.push({...x8[i],next:i+1})
            }
            return x9
        }else if(type=='founded year (old)'){
            const x3=x2.toSorted((a, b)=>a.founded-b.founded)
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='founded year (new)'){
            const x3=x2.toSorted((a, b)=>b.founded-a.founded)
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='market cap'){
            const x3=x2.toSorted((a, b)=>convert_num1(b.market_cap)-convert_num1(a.market_cap))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='net income'){
            console.log('')
            const x3=x2.toSorted(
                (a, b)=>convert_num1(b.net_income)-convert_num1(a.net_income))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='revenue'){
           const x3=x2.toSorted((a, b)=>convert_num1(b.revenue)-convert_num1(a.revenue))
           const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='asset'){
            const x3=x2.toSorted((a, b)=>convert_num1(b.asset)-convert_num1(a.asset))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='equity'){
            const x3=x2.toSorted((a, b)=>convert_num2(b.equity)-convert_num2(a.equity))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else{
            const x3=x2.toSorted((a, b)=>convert_num1(b.market_cap)-convert_num1(a.market_cap)).filter(x => x.risk?.length ==5)
            const x4=x3.toSorted((a, b) =>b.risk[4]['overall risk']-a.risk[4]['overall risk'])
            const x5=x4.toSorted((a, b) =>Number(b.return.replace('%','').replace('+','')) -Number(a.return.replace('%','').replace('+','')))
            const x6=[]
            for(let i=0;i<x5.length;i++){
                x6.push({...x5[i],next:i+1})
            }
            console.log('return:',x6.map(x=>x.return))
            return x6
        }
    }
    function reorder_return2(x1){ //item
        const x2=[]
        console.log(x1)
        for(let i=0;i<x1.length;i++){
            if(stock_graph1[stock_graph1.findIndex((x)=>x._id==x1[i].item._id)].itemsbox.map(x3=>x3.return)[term]!=undefined){
                let x3=convert_num1(x1[i].item.market_cap)
                let x4=0
                if(x3>1000000000000){
                    x4=120
                }else if(x3>1000000000){
                    x4=60
                }else {
                    x4=45
                }
                if(x1[i].item.symbol!='GOOG'){
                    x2.push({_id:x1[i].item._id,name:x1[i].item.name,symbol:x1[i].item.symbol,return:stock_graph1[stock_graph1.findIndex((x)=>x._id==x1[i].item._id)].itemsbox.map(x3=>x3.return)[term],employee:x1[i].item.employee,founded:x1[i].item.founded,market_cap:x1[i].item.market_cap,revenue:x1[i].item.revenue,net_income:x1[i].item.net_income,asset:x1[i].item.asset,equity:x1[i].item.equity,risk:x1[i].item.risk,prev:i+1,w:x4,value:x3})
                }
            }else{
                x2.push({'symbol':x1[i].item.symbol,'return':'0%'})
            }
        }
        if(type=='risk'){
            const x3=x2.filter(x =>x.risk?.length==5)
            const x4=x3.toSorted((a, b)=>convert_num1(b.market_cap)-convert_num1(a.market_cap))
            const x5=x4.toSorted((a, b) =>b.risk[4]['overall risk']-a.risk[4]['overall risk'])
            const x6=[]
            for(let i=0;i<x5.length;i++){
                x6.push({...x5[i],next:i+1})
            }
            return x6
        }else if(type=='employee'){
            const x7=x2.filter(x6=>x6.employee!='')
            const x8= x7.toSorted((a, b) =>Number(b.employee) -Number(a.employee))
            const x9=[]
            for(let i=0;i<x8.length;i++){
                x9.push({...x8[i],next:i+1})
            }
            return x9
        }else if(type=='founded year (old)'){
            const x3=x2.toSorted((a, b)=>a.founded-b.founded)
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='founded year (new)'){
            const x3=x2.toSorted((a, b)=>b.founded-a.founded)
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='market cap'){
            const x3=x2.toSorted((a, b)=>convert_num1(b.market_cap)-convert_num1(a.market_cap))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='net income'){
            console.log('')
            const x3=x2.toSorted(
                (a, b)=>convert_num1(b.net_income)-convert_num1(a.net_income))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='revenue'){
           const x3=x2.toSorted((a, b)=>convert_num1(b.revenue)-convert_num1(a.revenue))
           const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='asset'){
            const x3=x2.toSorted((a, b)=>convert_num1(b.asset)-convert_num1(a.asset))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else if(type=='equity'){
            const x3=x2.toSorted((a, b)=>convert_num2(b.equity)-convert_num2(a.equity))
            const x4=[]
            for(let i=0;i<x3.length;i++){
                x4.push({...x3[i],next:i+1})
            }
            return x4
        }else{
            const x3=x2.toSorted((a, b)=>convert_num1(b.market_cap)-convert_num1(a.market_cap)).filter(x => x.risk?.length ==5)
            const x4=x3.toSorted((a, b) =>b.risk[4]['overall risk']-a.risk[4]['overall risk'])
            const x5=x4.toSorted((a, b) =>Number(b.return.replace('%','').replace('+','')) -Number(a.return.replace('%','').replace('+','')))
            const x6=[]
            for(let i=0;i<x5.length;i++){
                x6.push({...x5[i],next:i+1})
            }
            console.log('return:',x6.map(x=>x.return))
            return x6
        }
    }
    function reorder_market_cap(x6){
        const industryList3=[]
        for(let x7 of x6){
            let x9=0
            for(let x8 of x7.item){
            x9+=convert_num1(x8.market_cap)
            }
            industryList3.push({'industry':x7.industry,'item':x7.item,'market_cap_calc':x9,'market_cap':convert_num3(x9)})
        }
        return industryList3.toSorted((a, b)=>b.market_cap_calc-a.market_cap_calc)
    }
    function reorder_market_cap2(x6){
        const x10=[]
        for(let x7 of x6){
            let x9=0
            x9+=convert_num1(x7.market_cap)
            x10.push({'item':x7,'market_cap_calc':x9,'market_cap':convert_num3(x9)})
        }
        return x10.toSorted((a, b)=>b.market_cap_calc-a.market_cap_calc)
    }
    const Treemap1=({data},x2)=>{
        const svgRef = useRef()
        useEffect(()=>{
            const svg=d3.select(svgRef.current)
            svg.selectAll("*").remove() 
            const width=`${selectedLimit=='catg 10'&&window.screen.width<850?window.screen.width-(window.screen.width*.2):190}`
            const height=`${selectedLimit=='catg 10'?100:400}`
            const root = d3.hierarchy(data).sum(x => x.value).sort((a,b)=>b.value-a.value)
            d3.treemap()
                .size([width,height])
                .padding(1)(root)
            svg.attr("width",width).attr("height",height)
            const tile=svg
                .selectAll("g")
                .data(root.leaves())
                .enter()
                .append("g")
                .attr("transform",x=>`translate(${x.x0},${x.y0})`)
            tile.append("rect")
                .attr("id",x=>x.data.name)
                .attr("width",x=>x.x1 - x.x0)
                .attr("height",x=>x.y1 - x.y0)
                .attr("fill",x=>`${Number(x.data.return.replace('%','').replace('+',''))>0?'#6a272a':'#2e4665'}`)
                .attr("xlink:href", d => d.data.link)
                .attr("rx",4)
                .attr("ry",4) 
                .on("mouseover", function(e, x) {
                    d3.select(this).style('fill',x=>`${Number(x.data.return.replace('%','').replace('+',''))>0?'rgb(106 39 42/0.9)':'rgb(46 70 101/0.9)'}`)
                    d3.select("#tooltip")
                    .style("visibility", "visible")
                    .html(`${x.data.name}<br>${x.data.symbol}<br>${x.data.return}<br>${type=='return'||type=='risk'?`${type=='risk'?x.data.risk[4]['overall risk']:''}`:`${x.data[`${type=='market cap'?'market_cap':''}${type=='net income'?'net_income':''}${type=='revenue'||type=='asset'||type=='employee'||type=='equity'?type:''}${type=='founded year (new)'||type=='founded year (old)'?'founded':''}`]}`}`)
                    .style("left", (e.pageX + 5) + "px") 
                    .style("top", (e.pageY - 35) + "px");
                })
                .on("mousemove", function(e) {
                    d3.select("#tooltip")
                    .style("left", (e.pageX + 5) + "px")
                    .style("top", (e.pageY - 35) + "px");
                })
                .on('mouseout', function() {
                    d3.select(this).style('fill',x=>`${Number(x.data.return.replace('%','').replace('+',''))>0?'#6a272a':'#2e4665'}`)
                    d3.select("#tooltip").style("visibility", "hidden");
                })
                 .on('click', function(e, d) {
                    setSelectedStock1(stock_graph1[stock_graph1.findIndex((x1)=>x1._id==d.data._id)])
                    setSelectedStocki1(stock_graph1.findIndex((x1)=>x1._id==d.data._id))
                })
                .on('touchstart', function(e, d) {
                    setSelectedStock1(stock_graph1[stock_graph1.findIndex((x1)=>x1._id==d.data._id)])
                    setSelectedStocki1(stock_graph1.findIndex((x1)=>x1._id==d.data._id))
                })
            tile.append("text")
                .attr("clip-path",x=>`url(#clip-${x.data.name})`)
                .selectAll("tspan")
                .data(x=>[x.data.name,x.data.symbol,x.data.return,`${type=='return'||type=='risk'?`${type=='risk'?x.data.risk[4]['overall risk']:''}`:`${x.data[`${type=='market cap'?'market_cap':''}${type=='net income'?'net_income':''}${type=='revenue'||type=='asset'||type=='employee'||type=='equity'?type:''}${type=='founded year (new)'||type=='founded year (old)'?'founded':''}`]}`}`])
                .enter()
                .append("tspan")
                .attr("x",(x, i)=>`${i>1?34:4}`)
                .attr("y",(x, i)=>`${13+i*10}`)
                .text(x => x)
                .style("fill", "#fff")
                .style("font-size", "9px")
                .style("cursor","default")
                .style("font-size", (x, i) => {
                    return i==0?'7px':'9px';
                })
                .style("font-weight", (x, i) => {
                    return i==1?'bold':'normal';
                })
                .style("text-align", (x, i) => {
                    return i>2?'right':'left';
                })
        }, [data])
        return <div id='chart-container'>
            <svg ref={svgRef}>
            </svg>
            <div id="tooltip" style={{
                position: 'absolute',
                visibility: 'hidden',
                background: 'rgba(255, 255, 255, 0.9)',
                border: '1px solid #ccc',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: 'none'
            }}></div>
        </div>
    }
    const Treemap2=({data},x2)=>{
        const svgRef = useRef()
        useEffect(()=>{
            const svg=d3.select(svgRef.current)
            svg.selectAll("*").remove() 
            const width=`${window.screen.width<850?window.screen.width-(window.screen.width*.2):760}`
            const height=`${window.screen.width<850?400:250}`
            const root = d3.hierarchy(data).sum(x => x.value).sort((a,b)=>b.value-a.value)
            d3.treemap()
                .size([width,height])
                .padding(1)(root)
            svg.attr("width",width).attr("height",height)
            const tile=svg
                .selectAll("g")
                .data(root.leaves())
                .enter()
                .append("g")
                .attr("transform",x=>`translate(${x.x0},${x.y0})`)
            tile.append("rect")
                .attr("id",x=>x.data.name)
                .attr("width",x=>x.x1 - x.x0)
                .attr("height",x=>x.y1 - x.y0)
                .attr("fill",x=>`${Number(x.data.return.replace('%','').replace('+',''))>0?'#6a272a':'#2e4665'}`)
                .attr("xlink:href", d => d.data.link)
                .attr("rx",4)
                .attr("ry",4) 
                .on("mouseover", function(e, x) {
                    d3.select(this).style('fill',x=>`${Number(x.data.return.replace('%','').replace('+',''))>0?'rgb(106 39 42/0.9)':'rgb(46 70 101/0.9)'}`)
                    d3.select("#tooltip")
                    .style("visibility", "visible")
                    .html(`${x.data.name}<br>${x.data.symbol}<br>${x.data.return}<br>${type=='return'||type=='risk'?`${type=='risk'?x.data.risk[4]['overall risk']:''}`:`${x.data[`${type=='market cap'?'market_cap':''}${type=='net income'?'net_income':''}${type=='revenue'||type=='asset'||type=='employee'||type=='equity'?type:''}${type=='founded year (new)'||type=='founded year (old)'?'founded':''}`]}`}`)
                    .style("left", (e.pageX + 5) + "px") 
                    .style("top", (e.pageY - 35) + "px");
                })
                .on("mousemove", function(e) {
                    d3.select("#tooltip")
                    .style("left", (e.pageX + 5) + "px")
                    .style("top", (e.pageY - 35) + "px");
                })
                .on('mouseout', function() {
                    d3.select(this).style('fill',x=>`${Number(x.data.return.replace('%','').replace('+',''))>0?'#6a272a':'#2e4665'}`)
                    d3.select("#tooltip").style("visibility", "hidden");
                })
                //  .on('click', function(e, d) {
                //     setSelectedStock1(stock_graph1[stock_graph1.findIndex((x1)=>x1._id==d.data._id)])
                //     setSelectedStocki1(stock_graph1.findIndex((x1)=>x1._id==d.data._id))
                // })
                // .on('touchstart', function(e, d) {
                //     setSelectedStock1(stock_graph1[stock_graph1.findIndex((x1)=>x1._id==d.data._id)])
                //     setSelectedStocki1(stock_graph1.findIndex((x1)=>x1._id==d.data._id))
                // })
            tile.append("text")
                .attr("clip-path",x=>`url(#clip-${x.data.name})`)
                .selectAll("tspan")
                .data(x=>[x.data.name,x.data.symbol,x.data.return,`${type=='return'||type=='risk'?`${type=='risk'?x.data.risk[4]['overall risk']:''}`:`${x.data[`${type=='market cap'?'market_cap':''}${type=='net income'?'net_income':''}${type=='revenue'||type=='asset'||type=='employee'||type=='equity'?type:''}${type=='founded year (new)'||type=='founded year (old)'?'founded':''}`]}`}`])
                .enter()
                .append("tspan")
                .attr("x",(x, i)=>`${i>1?34:4}`)
                .attr("y",(x, i)=>`${13+i*10}`)
                .text(x => x)
                .style("fill", "#fff")
                .style("font-size", "9px")
                .style("cursor","default")
                .style("font-size", (x, i) => {
                    return i==0?'7px':'9px';
                })
                .style("font-weight", (x, i) => {
                    return i==1?'bold':'normal';
                })
                .style("text-align", (x, i) => {
                    return i>2?'right':'left';
                })
        }, [data])
        return <div id='chart-container'>
            <svg ref={svgRef}>
            </svg>
            <div id="tooltip" style={{
                position: 'absolute',
                visibility: 'hidden',
                background: 'rgba(255, 255, 255, 0.9)',
                border: '1px solid #ccc',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: 'none'
            }}></div>
        </div>
    }
    function data2_2(data2_1){
        const data2_2 = {
            name: "root",
            children: data2_1,
        }
        return data2_2
    }
    function c_list2(){
        const c_list1=[]
        for(let i1=2010;i1<Number(new Date().getFullYear()+1);i1++){
            for(let i2=1;i2<13;i2++){
                let i3=0
                let d_list1=[]
                let d_list2=[]
                const i4=new Date(new Date(i1,i2-1,1)).toString()
                if(i4.includes('Mon')){
                    i3=1
                }else if(i4.includes('Tue')){
                    i3=2
                    d_list1.push('-')
                    d_list1.push('-')
                }else if(i4.includes('Wed')){
                    i3=3
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                }else if(i4.includes('Thu')){
                    i3=4
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                }else if(i4.includes('Fri')){
                    i3=5
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                }else if(i4.includes('Sat')){
                    i3=6
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                    d_list1.push('-')
                }
                for(let i5=1;i5<Number(new Date(i1,i2,0).getDate()+1);i5++){
                    if(i1==2010&&i2==1){
                        d_list1.push(30,31)
                        d_list2.push(['-','-','-','-','-','-','-'],['-','-','-','-','-','-','-'],['-','-','-','-','-','-','-'],['-','-','-','-','-','-','-'],d_list1)
                        d_list1=[]
                        i5+=100
                    }else{
                        if(i5<10){
                            d_list1.push(`0${i5}`)
                        }else{
                            d_list1.push(i5)
                        }
                    }
                    if(d_list1.length==7){
                        d_list2.push(d_list1)
                        d_list1=[]
                    }
                    if(
                        i1==Number(new Date().getFullYear())&&
                        i2==Number(new Date().getMonth()+1)&&
                        i5==Number(new Date(i1,i2,0).getDate())
                        // i5==Number(new Date().getDate())
                    ){
                        if(i1==2026&&i2==3){
                            d_list2.push(d_list1)
                        }
                        i5+=100
                    }
                    
                }
                if(i2<10){
                    c_list1.push({y:i1,m:`0${i2}`,d:d_list2})
                }else{
                    c_list1.push({y:i1,m:i2,d:d_list2})
                }
                if(i1==Number(new Date().getFullYear())&&i2==Number(new Date().getMonth()+1)){
                    i2=100
                }
            }
        }
        return c_list1
    }
    const onClick2StEnd=async(x)=>{
        if(new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()<new Date(`${st.date}`).getTime()){
            setSt({date:`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`,price:st.price})
        }else{
            setEnd({date:`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`,price:end.price})
        }
        try{
            setLoadingPrice(true)
            const { data: res } = await axios.post(`${APIURL1}/stock/stock_price`,{symbol:selectedStock1.symbol,date:`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`})
            if(new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()<new Date(`${st.date}`).getTime()){
                setSt(res.info)
            }else{
                setEnd(res.info)
            }
            setLoadingPrice(false)
        }catch(err){
            console.log(err)
        }
    }
    const onClick2SelectMenu=(x)=>{
        if(x=='catg 10'||x=='catg all'||x=='all'){
            setSelectedLimit(x)
        }
        if(x==3){
            setSelectMenu3(!selectMenu3)
        }
        if(x==4){
            setSelectMenu4(!selectMenu4)
        }
        if(x==5){
            setSelectMenu5(!selectMenu5)
        }
        setYCurUpdate1(yCurUpdate1+1)
        yCurUpdate2(yCurUpdate1.toString())
    }
    const onClick2MainPage=()=>{
        setPage('mainpage')
    }
    const onClick2SignUpPage=()=>{
        setPage('registerpage')
    }
    const onClick2RemoveMsg=()=>{
        setMsg('')
    }
    const onClick2LoginPage =()=>{
        setPage('loginpage')
    }
    const onChange2NewAccountInput =({currentTarget:input})=>{setAccount({...account,[input.name]:input.value})}
    const onClick2Register=async(e)=>{
        var td=new Date()
        var dd=String(td.getDate()).padStart(2,'0')
        var mm=String(td.getMonth()+1).padStart(2,'0')
        var yyyy=td.getFullYear()
        td=dd+mm+yyyy
        e.preventDefault()
        try {
            const {data:res}=await axios.post(`${APIURL1}/register1`,{'_id':Math.floor(Math.random()*1000).toString(),'created_date':td,'confirm':Math.floor(Math.random()*1000).toString(),...account})
            setMsg('')
            setPage('userpage')
            //your account is created. Please confirm your accunt from your email.
            setMsg(res.msg)
            } catch (err) {
            if (err.response && err.response.status >= 400 && err.response.status <= 500) {
                setMsg(err.response.data.msg)
            }
        }
    }
    const onClick2Login=async(e)=>{
        e.preventDefault()
        try {
            const {data:res} = await axios.post(`${APIURL1}/login1`,account)
            console.log(res)
        if(res.errmsg!=undefined){
            setMsg(res.errmsg)
        }else{
            localStorage.setItem('account_token', res.token_info.token)
            loginData1({
                id:res.user.id,
                username:res.user.username,
                email:data.email,
                pwd:data.pwd,
                iatstring:new Date(Number(res.tokenInfo.iat)*1000).toString(),
                expstring:new Date(Number(res.tokenInfo.exp)*1000).toString(),
                iat:Number(res.tokenInfo.iat),
                exp:Number(res.tokenInfo.exp)
            })
            setPage('mainpage')
        //     setJustLogined(true)
        //     setMsg(res.msg)
        //     const remove = setTimeout(() => {
        //     setMsg('')
        //     }, 3000)
        //     return () => clearTimeout(remove)
        }
        } catch (err) {
            if (err.response && err.response.status >= 400 && err.response.status <= 500) {
                setMsg(err.response.data.msg)
            }
        }
        setMsg('')
    }
//     const Login = ({ loginData1 }) => {
//         const [msg, setMsg] = useState('')
//         const [subMsg1, setSubMsg1] = useState('')
//         const [subMsg2, setSubMsg2] = useState('')
//         const [errMsg, setMsg] = useState('')
//         const [err, setErr] = useState('')
//         const [data, setData] = useState({username:'', email: '', role:'', iatstring:'', expstring:'',iat:'', exp:'', users:[{id:'',firstname:'',lastname:'',email:'',pwd:'',role:''}]})
//         const [justLogined, setJustLogined] = useState(false)
//         const [isExpired, setIsExpired] = useState(true)
//         const [page, setPage] = useState('Login')
//         const onChangeInput = ({ currentTarget: input }) => { setData({ ...data, [input.name]: input.value }) }
//         //one time passcode
//         const onChange2Input = ({ currentTarget: input }) => { setUpdateData({ ...updateData, [input.name]: input.value }) }
//         //set new pwd
//         const onChange3Input = ({ currentTarget: input }) => { setData3({ ...data3, id: updateData.id, [input.name]: input.value }) }
//         //set pwd
//         const [updateData, setUpdateData] = useState({
//             id: '',
//             token: ''
//         })
//         const [err2, setErr2] = useState('')
//         const [data3, setData3] = useState({
//             id: '',
//             pwd: '',
//             pwd2: ''
//         })
//         const onClick2CloseMsg = async (e) => {
//             e.preventDefault()
//             setMsg('')
//         }
//         const onClick2CloseErrMsg = async (e) => {
//             e.preventDefault()
//             setMsg('')
//         }
//   const onClick2Login = async (e) => {
//     e.preventDefault()
//     try {
//       const { data: res } = await axios.post(`${APIURL1}/login`, data)
//       if(res.errmsg!=undefined){
//         setMsg(res.errmsg)
//       }else{
//         localStorage.setItem('token', res.tokenInfo.token)
//         loginData1({
//           id:res.user.id,
//           username:res.user.username,
//           email:data.email,
//           pwd:data.pwd,
//           role:res.user.role,
//           msg:res.msg,
//           iatstring:new Date(Number(res.tokenInfo.iat)*1000).toString(),
//           expstring:new Date(Number(res.tokenInfo.exp)*1000).toString(),
//           iat:Number(res.tokenInfo.iat),
//           exp:Number(res.tokenInfo.exp),
//           justLogined:'true',
//           users:res.users
//         })
//         setJustLogined(true)
//         setMsg(res.msg)
//         const remove = setTimeout(() => {
//           setMsg('')
//         }, 3000)
//         return () => clearTimeout(remove)
//       }
//     } catch (err) {
//       if (err.response && err.response.status >= 400 && err.response.status <= 500) {
//         setMsg(err.response.data.msg)
//       }
//     }
//     setErr('')
//   }  
//   const onClick2Register = async(e) => {
//     console.log({ ...data, ['id']: Math.floor(Math.random()*1000).toString(),['role']:'normal'})
//     e.preventDefault()
//     try {
//       const { data: res } = await axios.post(`${APIURL1}/register`, { ...data, ['id']: Math.floor(Math.random()*1000).toString(),['role']:'normal'})
//       setData({ email: '', pwd: '' })
//       setErr('')
//       setPage('Login')
//       setMsg(res.msg)
//     } catch (err) {
//       if (err.response && err.response.status >= 400 && err.response.status <= 500) {
//         setErr(err.response.data.msg)
//       }
//     }
//   }
//   //sned onetime passcode
//   const onClick2SendOTP = async (x) => {
//     setErr('')
//     try{
//       const { data: res } = await axios.post(`${APIURL1}/otp/send`,{email:x,otp:Math.floor(Math.random()*10000).toString()})
//       setSubMsg1(res.msg)
//     }catch(err){console.log(err)}
//   }
//   const onClick2LoginWithOTP = async (e) => {
//     e.preventDefault()
//     try{
//       const { data: res } = await axios.post(`${APIURL1}/otp/login`,updateData)
//       if(res.msg!='You are logined.'){
//         setSubMsg2(res.msg)
//       }else{
//         localStorage.setItem('token', res.tokenInfo.token)
//         loginData1({
//           id:res.user.id,
//           username:res.user.username,
//           email:data.email,
//           pwd:data.pwd,
//           role:res.user.role,
//           msg:res.msg,
//           iatstring:new Date(Number(res.tokenInfo.iat)*1000).toString(),
//           expstring:new Date(Number(res.tokenInfo.exp)*1000).toString(),
//           iat:Number(res.tokenInfo.iat),
//           exp:Number(res.tokenInfo.exp),
//           justLogined:'true',
//           users:res.users
//         })
//         setJustLogined(true)
//         setMsg(res.msg)
//         const remove = setTimeout(() => {
//           setMsg('')
//         }, 3000)
//         return () => clearTimeout(remove)
//       }
//     } catch (err) {
//       if (err.response && err.response.status >= 400 && err.response.status <= 500) {
//         setMsg(err.response.data.msg)
//       }
//     }
//   }
//   const onSubmit2NewPwd = async (e) => {
//     e.preventDefault()
//     console.log('data3', data3)
    
//   }
//   const onClick2toLoginPage = async (e) => {
//     e.preventDefault()
//     setData({ email: '', pwd: '' })
//     setErr('')
//     setPage('Login')
//   }
//   const onClick2toRegisterPage = async (e) => {
//     e.preventDefault()
//     setData({ email: '', pwd: '' })
//     setErr('')
//     setPage('Create Account')
//   }
//   const onClick2toOnetimePasscodeLoginPage = async (e) => {
//     setMsg('')
//     e.preventDefault()
//     setPage('Onetime Passcode Login')
//   }
//   const optionTabs = [
//     {
//       ttl: 'Login',
//       table: <><div className='login-container'>
//         <div className='notification-container'>
//           {msg && <div className='notification flex flex-row justify-between'><div>{msg}</div><div><IoIosClose onClick={onClick2CloseMsg}/></div></div>}
//           {errMsg && <div className='account-err-msg flex flex-row justify-between'><div>{errMsg}</div><div><IoIosClose onClick={onClick2CloseErrMsg}/></div></div>}
//         </div>
//         <div className='login-nav'>Login</div>
//         <div className='login-input-container'>
//             <div className='text-left'>
//               <label>Account Email</label><br/>
//               <input className='create-new-account-input' type='email' name='email' value={data.email} onChange={onChangeInput} />
//             </div>
//             <div className='text-left'>
//               <label>Password</label><br/>
//               <input className='create-new-account-input' type='text' name='pwd' value={data.pwd} onChange={onChangeInput} />
//             </div>
//             {err && <div className='create-new-account-err'>{err}</div>}
//             <button className='login-btn' onClick={onClick2Login} disabled={!(data.email && data.pwd)}
//             >Login</button>
//           <button onClick={onClick2toOnetimePasscodeLoginPage} className='link-btn'>One time passcode login</button>
//           <button onClick={onClick2toRegisterPage} className='link-btn'>Create your account</button>
//         </div>
//       </div></>
//     },
//     {
//       ttl: 'Create Account',
//       table: <><div className='login-container'>
//         <div className='notification-container'>
//           {msg && <div className='notification flex flex-row justify-between'><div>{msg}</div><div><IoIosClose onClick={onClick2CloseMsg}/></div></div>}
//           {errMsg && <div className='account-err-msg flex flex-row justify-between'><div>{errMsg}</div><div><IoIosClose onClick={onClick2CloseErrMsg}/></div></div>}
//         </div>
//         <div className='login-nav'>Register</div>
//         <div className='login-input-container'>
//             <div className='text-left'>
//               <label>Username</label><br/>
//               <input className='create-new-account-input' type='text' name='username' value={data.username} onChange={onChangeInput} />
//             </div>
//             <div className='text-left'>
//               <label>Email Address</label><br />
//               <input className='create-new-account-input' type='email' name='email' value={data.email} onChange={onChangeInput} />
//             </div>
//             <div className='text-left'>
//               <label>Set Password</label><br />
//               <input className='create-new-account-input' type='text' name='pwd' value={data.pwd} onChange={onChangeInput} />
//             </div>
//             {err && <div className='create-new-account-err'>{err}</div>}
//             <button
//               className='register-btn'
//               type='button'
//               onClick={onClick2Register}
//               disabled={!(data.username && data.email && data.pwd)}
//             >Register</button>
//           <button onClick={onClick2toLoginPage} className='link-btn'>Already have account? Back to Login </button>
//         </div>
//       </div></>
//     },
//     {
//       ttl: 'Onetime Passcode Login',
//       table: <><div className='login-container'>
//         <div className='notification-container'>
//           {/* {msg && <div className='notification flex flex-row justify-between'><div>{msg}</div><div><IoIosClose onClick={onClick2CloseMsg}/></div></div>} */}
//           {/* {errMsg && <div className='account-err-msg flex flex-row justify-between'><div>{errMsg}</div><div><IoIosClose onClick={onClick2CloseErrMsg}/></div></div>} */}
//         </div>
//         <div className='login-nav'>One-time Passcode Login</div>
//         {isExpired ? <>
//           <div className='login-input-container'>
//               <div className='text-left'>
//                 <label>Account Email</label><br/>
//                 <input className='create-new-account-input' type='email' name='email' value={data.email} onChange={onChangeInput} />
//               </div>
//               {subMsg1 && <div className='account-sub-msg'>{subMsg1}</div>}
//               {err && <div className='create-new-account-err'>{err}</div>}
//               <button onClick={()=>onClick2SendOTP(data.email)} className='login-btn' disabled={!(data.email)}>Send</button>
//             <br />
//             <div className='text-left mb-4'>
//               <div>
//                 <label>Account Email</label><br/>
//                 <input className='create-new-account-input' type='email' name='email' value={updateData.email} onChange={onChange2Input} />
//               </div>
//               <div>
//                 <label>One-time Passcode</label><br/>
//                 <input className='create-new-account-input' type='text' name='otp' value={updateData.otp} onChange={onChange2Input} />
//               </div>
//               {subMsg2 && <div className='account-sub-msg'>{subMsg2}</div>}
//               {err && <div className='create-new-account-err'>{err}</div>}
//               <div className='text-center'>
//               <button className='login-btn'
//                 disabled={!(updateData.email && updateData.otp)} onClick={onClick2LoginWithOTP}
//               >One-time Passcode Login</button>
//               </div>
//               </div>
//             <button onClick={onClick2toLoginPage} className='link-btn'>Go Back</button>
//             <button onClick={onClick2toRegisterPage} className='link-btn'>Create your account</button>
//           </div>
//         </> :
//           <div className='login-input-container'>
//             <form onSubmit={onSubmit2NewPwd}>
//               <div className='login-input-ttl'>Please set your new password</div>
//               <div className='login-input-txt'>
//                 <label>Account Id</label>
//                 {updateData.id}
//               </div>
//               <div>
//                 <label>Password</label>
//                 <input className='create-new-account-input' type='text' name='pwd' value={data3.pwd} onChange={onChange3Input} />
//               </div>
//               <div>
//                 <label>Confirm Password</label>
//                 <input className='create-new-account-input' type='text' name='pwd2' value={data3.pwd2} onChange={onChange3Input} />
//               </div>
//               {(data3.pwd2.length !== 0) && data3.pwd !== data3.pwd2 && <div className='create-new-account-err'>Please input same password</div>}
//               {err && <div className='create-new-account-err'>{err}</div>}
//               <button className='login-btn' disabled={!(data3.pwd && data3.pwd2)}>Send</button></form>
//             <button className='link-btn' onClick={onClick2ResetPwd}>Go Back</button>
//             <button className='link-btn' onClick={onClick2Register}>Create your account</button>
//           </div>}
//       </div>
//       </>
//     }
//   ]
//   return (
//     <>
//       {page === 'Login' ? <>{optionTabs[0].table}</> : <>{page === 'Create Account' ? <>{optionTabs[1].table}</> : <>{page === 'Onetime Passcode Login' ? <>{optionTabs[2].table}</> : <>{optionTabs[3].table}</>}</>}</>}
//     </>
//   )
//     }


    // const Logined = (props) => {
    // const [msg, setMsg] = useState('')
    // const [errMsg, setMsg] = useState('')
    // const [err, setErr] = useState('')
    // const [data, setData] = useState({username:'', email: '', pwd:'', role:'', iatstring:'', expstring:'',iat:'', exp:'', users:[{id:'',username:'',email:'',pwd:'',role:''}]})
    // const [updateData, setUpdateData] = useState({username:'', email: '', pwd:'',role:''})
    // const [selectedRole, setSelectedRole] = useState('')
    // const [justLogined, setJustLogined] = useState(false)
    // const [tokenChecked, setTokenChecked]=useState(false)
    // const [timer, setTimer] = useState('')
    // const [isExpired, setIsExpired] = useState(true)
    // const [updateUserId, setUpdateUserId] = useState(null)
    // const [edit, setEdit] = useState(false)
    // const [edit2, setEdit2] = useState(false)
    // const token = localStorage.getItem('token')
    // //User data
    // const Ref = useRef(null)
    // useEffect(() => {
    //     // when user clicked login
    //     if (props.loginData4 !== null) {
    //     //get tokenInfo, user, users
    //     const handleSubmit = async (e) => {
    //         if(justLogined === false){
    //         setMsg(props.loginData4.msg)
    //         setData(props.loginData4)
    //         await setData(props.loginData4)
    //         setJustLogined(true)
    //         }
    //         function expiredMsg() {
    //         setMsg('Token expired. Please login again')
    //         localStorage.removeItem('token')
    //         setTimeout(() => {
    //             window.location.reload()
    //         }, 6000)
    //         }
    //         setTimeout(expiredMsg, ((props.loginData4.exp - props.loginData4.iat)*1000))
    //         Ref.current = setInterval(() => {
    //         let x = new Date()
    //         const y = props.loginData4.exp - Date.parse(new Date())/1000
    //         if (y >= 0) {
    //         setTimer((Math.floor((y / 60 / 60 / 24)) > 1 ? Math.floor((y / 60 / 60 / 24)) + 'days ' :
    //         Math.floor((y / 60 / 60 / 24)) + 'day ') + (Math.floor((y / 60 / 60) % 24) > 9 ? Math.floor((y / 60 / 60) % 24) :
    //         '0' + Math.floor((y / 60 / 60) % 24)) +':' + (Math.floor((y / 60) % 60) > 9? Math.floor((y / 60) % 60):
    //         '0' + Math.floor((y / 60) % 60)) +':' +(Math.floor((y) % 60) > 9 ? Math.floor((y) % 60) :
    //         '0' + Math.floor((y) % 60)))
    //         }
    //         }, 1000)
    //     }
    //     setTimeout(handleSubmit, 5)
    //     }
    //     // when user refleshed page
    //     if(props.loginData4 === null && tokenChecked === false){
    //     const handleSubmit = async (e) => {
    //     try {
    //         const {data:res} = await axios.post(`${APIURL1}/tokencheck`, {token:token})
    //         setTokenChecked(true)
    //     if(res.msg !==undefined){
    //         setMsg(res.msg)
    //         const remove = setTimeout(() => {
    //         setMsg('')
    //         localStorage.removeItem('token')
    //         window.location.reload()
    //         }, 5000)
    //         remove()
    //     }else{
    //     await setData({
    //         id:res.user.id,
    //         username:res.user.username,
    //         email:res.user.email,
    //         pwd:res.user.pwd,
    //         role:res.user.role,
    //         msg:res.msg,
    //         iatstring:new Date(Number(res.tokenInfo.iat)*1000).toString(),
    //         expstring:new Date(Number(res.tokenInfo.exp)*1000).toString(),
    //         iat:Number(res.tokenInfo.iat),
    //         exp:Number(res.tokenInfo.exp),
    //         justLogined:'true',
    //         users:res.users
    //     })
    //     const expireTime =(Number(res.tokenInfo.exp) - Number(res.tokenInfo.iat))*1000
    //     function expiredMsg() {
    //     setMsg('Token expired. Please login again')
    //     setTimeout(() => {
    //     localStorage.removeItem('token')
    //     window.location.reload()
    //     }, 6000)
    //     }
    //     setTimeout(expiredMsg,expireTime)
    //     Ref.current = setInterval(() => {
    //     let x = new Date()
    //     //find time difference 10digit - 10digit (second)
    //     const y = (Number(res.tokenInfo.exp) - (Date.parse(new Date())/1000))
    //     if (y >= 0) {
    //     setTimer((Math.floor((y / 60 / 60)) > 1 ? Math.floor((y / 60 / 60 / 24 )) + 'days ' : Math.floor((y / 60 / 60 / 24)) + 'day ') + (Math.floor((y / 60 / 60) % 24) > 9 ? Math.floor((y / 60 / 60) % 24) : '0' + Math.floor((y / 60 / 60) % 24)) +':' + (Math.floor((y / 60) % 60) > 9? Math.floor((y / 60) % 60): '0' + Math.floor((y / 60) % 60)) +':' +(Math.floor((y) % 60) > 9 ? Math.floor((y) % 60) : '0' + Math.floor((y) % 60)))
    //     }
    //     }, 1000)
    //     }
    //     } catch (err) {
    //     console.error("Error")
    //     }
    //     }
    //     setTimeout(handleSubmit, 5)
    //     }
    // }, [data])
    // const onClick2CloseMsg = async (e) => {
    // e.preventDefault()
    // setMsg('')
    // }
    // const onClick2CloseErrMsg = async (e) => {
    //     e.preventDefault()
    //     setMsg('')
    // }
    // const onChange2Input = ({ currentTarget: input }) => {
    //     setUpdateData({ ...updateData, [input.name]: input.value })
    // }
    // const onChange2Select = (x) => {
    //     setUpdateData({ ...updateData, ['role']: x })
    // }
    // const onClick2Logout = (e) => {
    //     e.preventDefault()
    //     localStorage.removeItem('token')
    //     setMsg('See you soon!');
    //     window.location.reload()
    // }
    // // admin - user data
    // const onClick2UserDataCancel = async (e) => {
    //     e.preventDefault()
    //     setEdit2(false)
    // }
    // const onClick2UserEdit = (x) => {
    //     if(data.id==x.id && data.role == 'admin'){
    //         setEdit2(true)
    //         setUpdateUserId(null)
    //         setUpdateData(x)
    //     }else if(data.role == 'admin'){
    //         setUpdateUserId(x.id)
    //         setEdit2(false)
    //         setUpdateData(x)
    //     }else{
    //         setEdit(true)
    //     }
    // }
    // const onClick2UserUpdate = async (e) => {
    //     e.preventDefault()
    //     try {
    //     const { data: res } = await axios.post(`${APIURL1}/user/update`, {user:data,update_user:updateData})
    //     setMsg(res.msg)
    //     setData({...data, username:res.user.username, email:res.user.email, pwd:res.user.pwd, role:res.user.role, users:res.users})
    //     setUpdateUserId(null)
    //     const remove = setTimeout(() => {
    //         setMsg('')
    //         setEdit2(false)
    //     }, 3000)
    //     return () => clearTimeout(remove)
    //     } catch (err) {
    //     if (err.response && err.response.status >= 400 && err.response.status <= 500) {
    //         setMsg(err.response.data.msg)
    //     }
    //     }
    //     setErr('')
    // }
    // const onClick2UserDelete = async(x) => {
    //     try{
    //     const { data: res } = await axios.post(`${APIURL1}/user/delete`, {user:data,remove_user:{id:x}})
    //     setMsg(res.msg)
    //     if(data.id==x){
    //         localStorage.removeItem('token')
    //         setTimeout(() => {
    //         window.location.reload()
    //         }, 1000)
    //     }else{
    //         setData({...data, user:res.user, users:res.users})
    //     }
    // } catch(err){
    //     if (err.response && err.response.status >= 400 && err.response.status <= 500) {
    //         setMsg(err.response.msg)
    //     }
    // }
    // }
    // // admin - users data
    // const onClick2UsersCancel = async (e) => {
    //     e.preventDefault()
    //     setUpdateUserId('')
    //     setUpdateData({ lastname:'', firstname:'', email: '', pwd: '', role:'' })
    // }
    // return (
    //     <>
    //     <div className='login-container'>
    //     <div className='notification-container'>
    //     {msg && <div className='notification flex flex-row justify-between'><div>{msg}</div><div><IoIosClose onClick={onClick2CloseMsg}/></div></div>}
    //     {errMsg && <div className='account-err-msg flex flex-row justify-between'><div>{errMsg}</div><div><IoIosClose onClick={onClick2CloseErrMsg}/></div></div>}
    //     </div>
    //     {data.role === 'admin'? 
    //     <div>
    //         <div className='login-nav flex-row'>
    //         <div><span>Admin</span>Main Page</div>
    //         <div className='flex'>
    //         <div className='logout-container'>
    //         Login Token Ticket:<br/> {new Date(data.iatstring).getUTCMonth() + 1}.{new Date(data.iatstring).getUTCDate()}.{new Date(data.iatstring).getUTCFullYear()} {new Date(data.iatstring).toLocaleTimeString()} - {new Date(data.expstring).getUTCMonth() + 1}.{new Date(data.expstring).getUTCDate()}.{new Date(data.expstring).getUTCFullYear()} {new Date(data.expstring).toLocaleTimeString()}<br/>
    //         <IoTimeSharp />{timer} left
    //         </div>
    //         <div>
    //         <button
    //             className='logout-btn flex'
    //             onClick={onClick2Logout}
    //         ><FiLogOut />Logout</button>
    //         </div>
    //         </div>
    //         </div>
    //         <h4>Member Accounts</h4>
    //         <div className='login-admin-container'>
    //         <div className='ttl flex justify-items-start'>
    //             <div></div>
    //             <div>Account ID</div>
    //             <div>Username</div>
    //             <div>Email</div>
    //             <div>Pwd</div>
    //             <div>Role</div>
    //             <div></div>
    //         </div>
    //         <>{(data.users).map((x, key) =>
    //             <>{updateUserId !== x.id?
    //             <div className='item flex flex-row justify-items-start'>
    //             <div>{key+1}</div>
    //             <div>{x.id}</div>
    //             <div>{x.username}</div>
    //             <div>{x.email}</div>
    //             <div>*****</div>
    //             <div>{x.role}</div>
    //         <div className='flex btn-pc'><button onClick={()=> onClick2UserEdit(x)} className='edit-btn'>Edit</button>
    //         <button onClick={()=> onClick2UserDelete(x.id)} className='delete2-btn'>Delete</button></div>
    //         <div className='flex btn-sp'>
    //         <div className='edit2-btn' style={{maskImage: `url("data:image/svg+xml,${svgStringMdEdit}")`}}>
    //         <div className='edit2-btn-bg' onClick={()=> onClick2UserEdit(x)}></div></div>
    //         {/* <MdEdit onClick={()=> onClick2UserEdit(x)}/> */}
    //         <div className='delete3-btn' style={{maskImage: `url("data:image/svg+xml,${svgStringIoIosClose}")`}}>
    //         <div className='delete3-btn-bg' onClick={()=> onClick2UserDelete(x.id)}></div></div></div>
    //         </div> : <div className='item-edit flex flex-row justify-items-start text-left'>
    //         <div>{key+1}</div>
    //         <div>{x.id}</div>
    //         <div><input className='inputA' type='text' name='username' defaultValue={x.username} onChange={onChange2Input} />
    //         </div>
    //             <div><input className='inputA' type='email' name='email' defaultValue={x.email} onChange={onChange2Input} /></div>
    //             <div><input className='inputA' type='text' name='pwd' defaultValue={x.pwd} onChange={onChange2Input} /></div>
    //             <div><select name="role" defaultValue={x.role}
    //             onChange={(e)=>onChange2Select(e.target.value)}>
    //             <option value="admin">admin</option>
    //             <option value="normal">normal</option>
    //             </select></div>
    //             {err && <div className='create-new-account-err'>{err}</div>}
    //             <div className='flex'>
    //             <button onClick={onClick2UsersCancel} type='button'className='cancel-btn'>Cancel</button>
    //             <button onClick={onClick2UserUpdate} type='button' className='update2-btn'
    //             disabled={!(updateData.email && updateData.pwd && updateData.username)}>Update</button></div>
    //             </div>
    //             }</>
    //         )}</>
    //         <br/><br/>
    //         <h4>Your Account</h4>
    //         <div className='login-admin-container-user'>
    //             <div className='ttl flex justify-items-start'>
    //             <div></div>
    //             <div>Account ID</div>
    //             <div>Username</div>
    //             <div>Email</div>
    //             <div>Pwd</div>
    //             <div>Role</div>
    //             <div></div>
    //             </div>
    //         {edit2 !== false ?
    //             <div className='item-edit flex justify-items-start text-left'>
    //             <div></div>
    //             <div className='text-left'>{data.id}</div>
    //             <div><input className='inputA' type='text' name='username' defaultValue={data.username} onChange={onChange2Input} /></div>
    //             <div><input className='inputA' type='email' name='email' defaultValue={data.email} onChange={onChange2Input} /></div>
    //             <div><input className='inputA' type='text' name='pwd' defaultValue={data.pwd} onChange={onChange2Input} /></div>
    //             <div><select name="role" defaultValue={data.role}
    //             onChange={(e)=>onChange2Select(e.target.value)}>
    //             <option value="admin">admin</option>
    //             <option value="normal">normal</option>
    //             </select></div>
    //             <div className='flex'><button
    //             className='cancel-btn' onClick={onClick2UserDataCancel}
    //             >Cancel</button><button
    //             onClick={onClick2UserUpdate}
    //             className='text-left update2-btn'
    //             type='button'
    //             disabled={!(updateData.username&&updateData.email&&updateData.pwd)}
    //             >Update</button></div>
    //         {err && <div className='create-new-account-err'>{err}</div>} 
    //         </div> : <div className='item flex flex-row justify-items-start'><div></div><div>{data.id}</div><div>{data.username}</div><div>{data.email}</div><div>*****</div><div>{data.role}</div><div className='flex btn-pc'><button className='edit-btn' onClick={()=> onClick2UserEdit(data)}
    //         >Edit</button><button className='delete2-btn' onClick={()=> onClick2UserDelete(data.id)}>Delete Account</button></div><div className='flex btn-sp'>
    //         <div className='edit2-btn' style={{maskImage: `url("data:image/svg+xml,${svgStringMdEdit}")`}}>
    //         <div className='edit2-btn-bg' onClick={()=> onClick2UserEdit(data)}></div></div>
    //         <div className='delete3-btn' style={{maskImage: `url("data:image/svg+xml,${svgStringIoIosClose}")`}}>
    //         <div className='delete3-btn-bg' onClick={()=> onClick2UserDelete(data.id)}></div></div></div></div>}
    //         </div>
    //         <br />
    //         </div> 
    //         </div>:<>
    //         <div className='login-nav'>
    //         <div>Main Page</div>
    //         <div className='flex'>
    //         <div className='logout-container'>
    //         • This Login Token is available for <br/> {new Date(data.iatstring).getUTCMonth() + 1}.{new Date(data.iatstring).getUTCDate()}.{new Date(data.iatstring).getUTCFullYear()} {new Date(data.iatstring).toLocaleTimeString()} - {new Date(data.expstring).getUTCMonth() + 1}.{new Date(data.expstring).getUTCDate()}.{new Date(data.expstring).getUTCFullYear()} {new Date(data.expstring).toLocaleTimeString()}<br/>
    //         • You have {timer} left
    //         </div>
    //         <div>
    //         <button
    //             className='logout-btn flex'
    //             onClick={onClick2Logout}
    //         ><FiLogOut />Logout</button>
    //         </div>
    //         </div>
    //         </div>
    //         <div className='login-contents-container'
    //         >
    //         <div className='menu-item mb-4'><b>Change account details</b>
    //         {edit ? <button className='cancel-btn' onClick={() => setEdit(!edit)}>Cancel</button>:<button className='cancel-btn'
    //             onClick={()=> onClick2UserEdit(data)}>Edit</button>}
    //         </div>
    //         {edit ? <>
    //             <b>Account ID:{data.id}</b>
    //             <div>
    //             <label>Username</label><br/>
    //             <input className='create-new-account-input' type='text' name='username' defaultValue={updateData.username} onChange={onChange2Input} />
    //             </div>
    //             <div>
    //             <label>Email Address</label><br/>
    //             <input className='create-new-account-input' type='email' name='email' defaultValue={updateData.email} onChange={onChange2Input} />
    //             </div>
    //             <div>
    //             <label>Password</label><br/>
    //             <input className='create-new-account-input' type='text' name='pwd' defaultValue={updateData.pwd} onChange={onChange2Input} />
    //             </div>
    //             Role:{updateData.role}<br/>
    //             {err && <div className='create-new-account-err'>{err}</div>}
    //             <button
    //             className='update-btn'
    //             onClick={onClick2UserUpdate}
    //             disabled={!(updateData.username&&updateData.email&&updateData.pwd)}
    //             >Update</button>
    //         </> : <>Account ID: {data.id}<br />Username: {data.username}<br />Email Address: {data.email}<br />Password: *****
    //         <br />Role: {data.role}</>}
    //         <br />
    //         <div className='menu-item'>
    //             <b>Delete Account</b><br />
    //             <button
    //             className='delete-btn'
    //             onClick={()=> onClick2UserDelete(data.id)}
    //             >Delete Account</button>
    //         </div>
    //         </div>
    //         </>}
    //     </div>
    //     </>
    // )
    // }
    const optionTabs = [
        {
            ttl:'registerpage',
            table:<>
                <div>{msg!=''?<div className='flex justify-between p-[2px] rounded-[2px] bg-gray-100 border-[1px] border-gray-200 mt-[8px] mb-[8px]'><div>{msg}</div><div><IoCloseOutline className='font-bold cursor-default mt-[2px]' onClick={onClick2RemoveMsg}/></div></div>:''}
                <div className='flex-cols w-fit m-auto'>
                <div className='flex-cols'><div>set username</div><input className='mb-[4px] w-[140px] bg-transparent border-[.2px] border-gray-600 h-[20px] mb-[1px]' type='text' name='username' value={account.username} onChange={onChange2NewAccountInput}/></div>
                {account.username.length>11&&account.username.length>0?<span className='error-msg'>text exceeded.10 digit limit.</span>:''}
                <div className='flex-cols'><div>set email:</div><input className='mb-[4px] w-[140px] bg-transparent border-[.2px] border-gray-600 h-[20px] mb-[1px]' type='text' name='email' value={account.email} onChange={onChange2NewAccountInput}/></div>
                {!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(account.email))&& account.email.length>0?<span className='error-msg'>email has to be email format.</span>:''}
                <div className='flex-cols'><div>set password:</div><input className='w-[140px] bg-transparent border-[.2px] border-gray-600 h-[20px]' type='text' name='pwd' value={account.pwd} onChange={onChange2NewAccountInput}/></div>
                {account.pwd.length>11&&account.pwd.length>0?<span className='error-msg'>text exceeded. 10 digit limit.</span>:''}
                <div className='flex-cols'><div className='w-[50px]'></div><div disabled={!(account.username && account.email && account.pwd)} className={`h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default m-auto w-fit ${!(account.username && account.email && account.pwd)&&(!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(account.email))&&account.username.length<11&&account.pwd.length<11)?'bg-[#666870] cursor-not-allowed':''} bg-[#414c74] hover:bg-[#365c88]}`} onClick={onClick2Register} >Register</div></div>
                </div>
                <div className='flex-cols'>
                </div>
                </div>
                </>
        },
        {
            ttl:'loginpage',
            table:<div>
                {msg!=''?<div className='flex justify-between p-[2px] rounded-[2px] bg-gray-100 border-[1px] border-gray-200 mt-[8px] mb-[8px]'><div>{msg}</div><div><IoCloseOutline className='font-bold cursor-default mt-[2px]' onClick={onClick2RemoveMsg}/></div></div>:''}
                <div className='flex-cols w-fit m-auto'>
                <div className='flex-cols'><div>email:</div><input className='mb-[4px] w-[140px] bg-transparent border-[.2px] border-gray-600 h-[20px] mb-[1px]' type='text' name='email' value={account.email} onChange={onChange2NewAccountInput}/></div>
                <div className='flex-cols'><div>password:</div><input className='mb-[4px] w-[140px] bg-transparent border-[.2px] border-gray-600 h-[20px] mb-[2px]' type='text' name='pwd' value={account.pwd} onChange={onChange2NewAccountInput}/></div>
                <div className='flex-cols'><div className='w-[50px]'></div><div className={`h-[18px] mt-[2px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex text-white cursor-default m-auto w-fit ${stockAccount2.subscribe=='true'?' bg-[#414c74] hover:bg-[#365c88]':'bg-gray-300 hover:bg-gray-500'}`} onClick={onClick2Login} disabled={!(account.email && account.pwd)}>Login</div></div>
                </div>
                <div className='flex-cols'>
                </div>
                {/* {token ? <Logined loginData4={loginData3} /> : <><Login loginData1={loginupdateData} /></>} */}
                </div>
        },
        {
                ttl:'mainpage',
                table:<>{selectedStock1!=undefined?<>{account_token?<>
               user page</>:<> <div className='flex'><div className='flex'>{selectedStock1.symbol}x <IoTicketOutline className='mt-[2px] ml-[2px] mr-[2px]'/><div className='pt-[0px]'>{Math.floor(amount2/st.price)}</div></div></div>
                <div className='flex'><div className='mt-auto mb-auto flex'>{st.date.slice(8,10)}/{st.date.slice(5,7)}/{st.date.slice(0,4)}<div className='ml-[6px] mr-[6px]'>-</div>{end.date.slice(8,10)}/{end.date.slice(5,7)}/{end.date.slice(0,4)}</div><CiCalendarDate className='text-[16px] m-[2px] hover:bg-gray-300 hover:rounded-xs' onClick={()=>setSelectMenu6(!selectMenu6)}/></div> 
                {selectMenu6?<> <div className='flex justify-between'><MdArrowLeft className={`text-[24px] cursor-default mt-auto mb-auto hover:text-gray-300 ${c_list3[c_dsp].y==c_list3[0].y&&c_list3[c_dsp].m==c_list3[0].m?'invisible':''}`} onClick={x=>setc_dsp(c_dsp-1)}/><div className='font-bold'>{c_list3[c_dsp].m} {c_list3[c_dsp].y} </div><MdArrowRight className={`text-[24px] cursor-default mt-auto mb-auto hover:text-gray-300 ${c_list3[c_dsp].y==c_list3[c_list3.length-1].y&&c_list3[c_dsp].m==c_list3[c_list3.length-1].m?'invisible':''}`} onClick={x=>setc_dsp(c_dsp+1)}/></div>
                <div className='flex'>{w_list.map(x=><div className='text-center text-[8px] w-[28px]'>{x}</div>)}</div> 
                <div className='flex'>{c_list3[c_dsp].d[0].map(x=><div className={`text-center text-[8px] w-[28px] hover:font-bold cursor-default ${x=='-'?'opacity-[0]':''} ${new Date(st.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() || new Date(end.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()?'font-bold':''} ${new Date(st.date).getTime().toString().slice(0,13)<=new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() && new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()<=new Date(end.date).getTime().toString().slice(0,13)?'bg-gray-100':''}`} onClick={()=>onClick2StEnd(x)}>{x}</div>)}</div>
                {c_list3[c_dsp].d.length<2?'':<div className='flex'>{c_list3[c_dsp].d[1].map(x=><div className={`text-center text-[8px] w-[28px] hover:font-bold cursor-default ${x=='-'?'opacity-[0]':''} ${new Date(st.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() || new Date(end.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()?'font-bold':''} ${new Date(st.date).getTime().toString().slice(0,13)<=new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() && new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()<=new Date(end.date).getTime().toString().slice(0,13)?'bg-gray-100':''}`} onClick={()=>onClick2StEnd(x)}>{x}</div>)}</div>}
                {c_list3[c_dsp].d.length<3?'':<div className='flex'>{c_list3[c_dsp].d[2].map(x=><div className={`text-center text-[8px] w-[28px] hover:font-bold cursor-default ${x=='-'?'opacity-[0]':''} ${new Date(st.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() || new Date(end.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()?'font-bold':''} ${new Date(st.date).getTime().toString().slice(0,13)<=new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() && new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()<=new Date(end.date).getTime().toString().slice(0,13)?'bg-gray-100':''}`} onClick={()=>onClick2StEnd(x)}>{x}</div>)}</div>}
                {c_list3[c_dsp].d.length<4?'':<div className='flex'>{c_list3[c_dsp].d[3].map(x=><div className={`text-center text-[8px] w-[28px] hover:font-bold cursor-default ${x=='-'?'opacity-[0]':''} ${new Date(st.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() || new Date(end.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()?'font-bold':''} ${new Date(st.date).getTime().toString().slice(0,13)<=new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() && new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()<=new Date(end.date).getTime().toString().slice(0,13)?'bg-gray-100':''}`} onClick={()=>onClick2StEnd(x)}>{x}</div>)}</div>}
                {c_list3[c_dsp].d.length<5?'':<div className='flex'>{c_list3[c_dsp].d[4].map(x=><div className={`text-center text-[8px] w-[28px] hover:font-bold cursor-default ${x=='-'?'opacity-[0]':''} ${new Date(st.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() || new Date(end.date).getTime()==new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()?'font-bold':''} ${new Date(st.date).getTime().toString().slice(0,13)<=new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime() && new Date(`${c_list3[c_dsp].y}-${c_list3[c_dsp].m}-${x}`).getTime()<=new Date(end.date).getTime().toString().slice(0,13)?'bg-gray-100':''}`} onClick={()=>onClick2StEnd(x)}>{x}</div>)}</div>}</>:''}
                <div className='flex h-[24px]'><div className='mt-auto mb-auto'>Initial investment price: US$</div><input className='ml-[2px] border-[.1px] border-gray-400 w-[40px] text-right pl-[4px] pr-[4px]' type='text' value={amount2} onChange={onChange2Amount2}/></div>
                <div className='flex'>
                <div className='flex-col'>
                <div className='flex mr-[16px]'><div className='w-[24px]'>in:</div><div>{st.price}</div></div>
                <div className='flex mr-[16px]'><div className='w-[24px]'>out:</div><div>{end.price}</div></div>
                </div>
                <div className='flex-col'>
                    <div className='flex mr-[16px]'><div className='w-[30px]'>bit:</div><div>${Math.floor(Math.floor(amount2/st.price)*st.price)}</div></div>
                    <div className='flex mr-[16px]'><div className='w-[30px]'>return: </div><div>${Math.floor(Math.floor(amount2/st.price)*end.price)}</div></div>
                    <div className='flex mr-[16px]'><div className='w-[30px]'>profit: </div><div>${Math.floor(Math.floor(amount2/st.price)*end.price)-Math.floor(Math.floor(amount2/st.price)*st.price)}</div></div>
                </div>
                </div>
                <div className='flex h-fit'><div className='mt-auto mb-auto'>Estimated profit: </div><h2 className={`text-[16px] md:text-[20px] font-normal md:font-light ml-[4px] ${Math.floor(Math.floor(amount2/st.price)*end.price)-Math.floor(Math.floor(amount2/st.price)*st.price)>0?'text-[#2e4665]':'text-[#6a272a]'}`}>
                    {Math.floor(Math.floor(amount2/st.price)*end.price)-Math.floor(Math.floor(amount2/st.price)*st.price)<0?<>-US${(Math.floor(Math.floor(amount2/st.price)*end.price)-Math.floor(Math.floor(amount2/st.price)*st.price))*-1}</>:<>+US${Math.floor(Math.floor(amount2/st.price)*end.price)-Math.floor(Math.floor(amount2/st.price)*st.price)}</>}
                </h2><MdOutlineAutorenew className={`${loadingPrice?'animate-spin':''}`}/></div></>}</>:'loading..'}</>
        },
        {
            ttl:'mainpage',
            table:<div><div className='flex justify-between mb-[14px]'><div className='font-bold'></div>
                <div className='flex mt-auto mb-auto'><>
                {notificationEdit?<><button className='border-[.1px] border-gray-800 text-[9px] font-bold text-gray-800 pl-[6px] pr-[6px] bg-gray-100 hover:bg-gray-200 mr-[2px]' onClick={x=>setNotificationEdit(!notificationEdit)}>Cancel</button><button className='border-[.1px] border-gray-800 text-[9px] font-bold text-gray-800 pl-[6px] pr-[6px] bg-gray-100 hover:bg-gray-200' onClick={x=>setNotificationEdit(!notificationEdit)}>Save</button></>:<><MdModeEdit className='color-[#000] text-[14px] hover:text-gray-600' onClick={x=>setNotificationEdit(!notificationEdit)}/></>}</><ImBin2 className='ml-[2px] text-[12px] text-gray-800 hover:text-gray-600'/></div>
                </div>
                {notificationEdit?<div>
                <div className='w-[174px] flex justify-between ml-[20px]'><div className='mt-auto mb-auto'>Your Current Profit: </div><h2 className='text-[18px] ml-[2px]'>US$5K</h2></div>
                <div className='flex mr-[16px] mb-[2px]'>
                <div className='ml-[20px] mt-auto mb-auto mr-[8px]'>Symbol:</div>
                <div className='flex'><input className='border-[.1px] border-gray-400 h-[24px] w-[38px] text-right pl-[4px] pr-[6px] mr-[2px]' type='text' name='amount' value={stockAccount2.symbol} onChange={x=>onChange2AccountInfo()}/><div className='flex mt-auto mb-auto'>x <IoTicketOutline className='mt-[1px] mr-[2px]'/>1</div></div>
                </div>
                <div className='flex h-[24px] mb-[2px] ml-[16px]'><CiCalendarDate className='text-[16px] m-[2px]'/><input className='border-[.1px] border-gray-400 w-[72px] text-right pl-[4px] pr-[6px]' type='date' name='st' min='2010-01-30' max='2026-03-18' value={stockAccount2.st} onChange={x=>onChange2AccountInfo()}/><div className='mt-auto mb-auto ml-[6px] mr-[6px]'>-</div><input className='border-[.1px] border-gray-400 w-[72px] text-right pl-[4px] pr-[6px]' type='date' min='2010-01-30' max='2026-03-18' name='end' value={stockAccount2.end} onChange={x=>onChange2AccountInfo()}/></div>
                <div className='flex mr-[16px] mb-[2px]'>
                <div className='ml-[20px] w-[120px] mt-auto mb-auto'>Initial investment price:</div>
                <div className='flex'><div className='mt-auto mb-auto'>US$</div><input className='border-[.1px] border-gray-400 h-[24px] w-[38px] text-right pl-[4px] pr-[6px]' type='text' name='amount' value={stockAccount2.amount} onChange={x=>onChange2AccountInfo()}/></div>
                </div>
                <div className='flex mr-[16px] mb-[2px]'>
                <div className='ml-[20px] w-[120px] mt-auto mb-auto'>Current price:</div>
                <div className='flex'><div className='mt-auto mb-auto'>US$</div><input className='border-[.1px] border-gray-400 h-[24px] w-[38px] text-right pl-[4px] pr-[6px]' type='text' name='curr_price' value={stockAccount2.curr_price} onChange={x=>onChange2AccountInfo()}/></div>
                </div>
                <div className='w-[120px] flex justify-between mb-[8px]'>
                <div className='flex mr-[16px] h-fit'>
                <div className='ml-[20px] w-[24px] mt-auto mb-auto'>min:</div>
                <div className='flex'><div className='mt-auto mb-auto'>US$</div><input className='border-[.1px] border-gray-400 h-[24px] w-[39px] text-right pl-[4px] pr-[6px]' type='text' name='min' value={stockAccount2.min} onChange={x=>onChange2AccountInfo()}/></div>
                        </div>
                        <div className='flex'>
                        <div className='w-[24px] mt-auto mb-auto'>max:</div>
                        <div className='flex'><div className='mt-auto mb-auto'>US$</div><input className='border-[.1px] border-gray-400 h-[24px] w-[38px] text-right pl-[4px] pr-[6px]' type='text' name='max' value={stockAccount2.max} onChange={x=>onChange2AccountInfo()}/></div>
                        </div>
                    </div>
                </div>:<div>
                <div className='flex'><div className='mt-auto mb-auto flex'>Symbol: {stockAccount2.symbol}x <IoTicketOutline className='mt-[1px] mr-[2px]'/>1</div></div>
                <div className='flex'><CiCalendarDate className='text-[16px] m-[2px]'/><div className='mt-auto mb-auto'>{stockAccount2.st} - {stockAccount2.end}</div></div>
                <div className='flex'>
                <div className='mt-auto mb-auto w-[100px]'>Initial investment price:<br/>Current price:</div>
                <div className='mt-auto mb-auto'>US${stockAccount2.amount} <br/>US${stockAccount2.curr_price}</div>
                </div>
                <div className='w-[160px] flex justify-between mb-[8px]'>
                <div className='flex mr-[16px]'>
                <div className='w-[24px]'>min:</div>
                <div>{stockAccount2.min>0?<>+US${stockAccount2.min}</>:<>-US${stockAccount2.min*-1}</>}</div>
                </div>
                <div className='flex'>
                <div className='w-[24px]'>max:</div>
                <div>{stockAccount2.max>0?<>+US${stockAccount2.max}</>:<>-US${stockAccount2.max*-1}</>}</div>
                </div>
                </div>
                <div className='mt-auto mb-auto'>Your Current Profit: </div>
                <h2 className='text-[18px] ml-[2px]'>US$5K</h2>
                </div>}
                <div className='flex justify-between'><div className={`h-[18px] pl-[14px] pr-[14px] pt-[2px] pb-[2px] flex  text-white cursor-default ${stockAccount2.subscribe=='true'?' bg-[#414c74] hover:bg-[#365c88]':'bg-gray-300 hover:bg-gray-500'}`}><LuMail className='mt-auto mb-auto'/><div className='mt-[1px] text-[9px] ml-[4px]'>Subscribed</div></div></div></div>
        }
    ]
    return (
            <StyledContainer>
            <div className='flex justify-between md:max-w-[800px] md:m-auto'>
            <div>
            <h4 className='sample-title'>Stock Generator</h4>
            <div className='tag-container'>
            <span className='tech-tag'>React</span><span className='tech-tag'>Py</span><span className='tech-tag'>Y!Finance</span><span className='tech-tag'>MongoDB</span>
            </div>
            <div className='text-[7px] font-bold'>Stock Data Loading Time: {runtime}</div>
            </div>
            <div>
            {loadingMsg?'':<div className='hidden md:flex justify-end'>
            <div className='w-fit text-gray-800 flex md:flex-col md:bg-gray-100 md:rounded-md md:p-[8px]'>
            <div className='relative text-xs flex flex mr-[2px]'>
            <div className='flex'><IoSearch className='mt-[14px] md:mt-auto mb-auto text-[12px]'/><input type='text' value={searchSymbolTxt} onChange={onChange2SearchSymbol} className='border border-gray-950 ml-[1px] text-[12px] mt-auto h-[24px] md:h-auto w-[140px] md:w-[169px]'/></div>
            {searchSymbolTxt.length>0!=''?<div className='h-[190px] md:h-[70px] overflow-auto absolute z-[3] bg-white border border-gray-800 ml-[11.5px] w-full md:w-[169px] mt-[32px] md:mt-[17px] md:ml-[11.5px]'>{searchSymbolResult.map(x=><div className='hover:bg-gray-100 cursor-default text-[9px]' onClick={()=>onClick2Stock1(x)}>{x.symbol} {x.name}<br/></div>)}</div>:''}
            </div>
            <div className='flex md:mt-[4px]'>
            <div className='flex-col mr-[2px] relative'>
            <div className='font-bold text-[9px] leading-[1]'>industry ({industryList2.length})</div>
            <div className='h-[24px] md:h-auto flex border border-gray-800 bg-white w-full md:w-[120px] justify-between pl-[2px] text-[9px]' onClick={()=>setSelectMenu1(!selectMenu1)}>{selectedIndustry==''?<div className='w-fit m-auto text-[12px]'>-</div>:<div className='w-[80px] mt-auto mb-auto'>{selectedIndustry}</div>}{!selectMenu1?<MdKeyboardArrowDown className='mt-auto mb-auto text-[16px]'/>:<MdKeyboardArrowUp className='mt-auto mb-auto text-[16px]'/>}</div>{!selectMenu1?'':<div className='h-[190px] overflow-auto absolute z-[2] bg-white border border-gray-800 top-[32px] md:top-[23px] w-[115px] md:w-[120px] text-[9px] pl-[2px]'>{industryList2.map(x=><div value={x} className='hover:bg-gray-100 cursor-default' onClick={()=>onClick2FilterIndustry(x)}>{x.industry} ({x.item.length})</div>)}</div>}</div><div className='flex-col relative'><div className='font-bold text-[9px] leading-[1]'>symbol ({filterIndustry.length})</div>
            <div className='h-[24px] md:h-auto flex border border-gray-800 bg-white w-full md:w-[60px] pl-[2px] justify-between text-[9px]' onClick={()=>setSelectMenu2(!selectMenu2)}>{selectedIndustry==''?<><div className='w-fit m-auto text-[12px]'>-</div>{!selectMenu2?<MdKeyboardArrowDown className='mt-auto mb-auto text-[16px]'/>:<MdKeyboardArrowUp className='mt-auto mb-auto text-[16px]'/>}</>:<div className='flex justify-between'><div className='w-[40px] mt-auto mb-auto'>{selectedStock1.symbol}</div><div className='w-fit mt-auto mb-auto'>{!selectMenu2?<MdKeyboardArrowDown className='mt-auto mb-auto text-[16px]'/>:<MdKeyboardArrowUp className='mt-auto mb-auto text-[16px]'/>}</div></div>}</div>{!selectMenu2?'':<div className='h-[190px] overflow-auto absolute z-[2] bg-white border border-gray-800 right-[0px] top-[32px] w-[200px] md:w-[200px] md:right-[-139.5px] md:top-[23px]'>{filterIndustry.map(x=><div className='hover:bg-gray-100 cursor-default text-[9px] flex justify-between pr-[2px]' onClick={()=>onClick2Stock2(x)}><div className='pl-[2px]'>{x.symbol} {x.name}</div></div>)}</div>}</div>
            </div></div>
            </div>}
            </div>
            </div>
            {loadingMsg?
            <div className='md:max-w-[800px] md:m-auto'><p className='flex text-xs mt-[20px] md:mt-[4em] md:mb-[4em] w-[270px] m-auto'>Loading 5000+ stock items please wait for 10s<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p></div>
            :<>
            <div className='sample-contents-container-006 md:max-w-[800px] md:m-auto'>
            <div className='sample-title-container-006 flex-col flex'>
            <div className='text-[9px] ml-auto rate-tab flex w-fit block md:hidden'>{market.map((x, i) => (<button key={i} onClick={(e)=>onClick2Market(e,x.name)} className={`mr-[4px] ${selectedMarket === x.name ? 'underline text-gray-800' : undefined}`}
                >{x.name}</button>))}</div>
            <div className='inherit md:hidden justify-end flex md:flex-col md:bg-gray-100 md:rounded-md md:p-[8px] md:mt-[20px]'>
            <div className='relative text-xs flex flex mr-[2px]'>
            <div className='flex'><IoSearch className='mt-[14px] md:mt-auto mb-auto text-[12px]'/><input type='text' value={searchSymbolTxt} onChange={onChange2SearchSymbol} className='border border-gray-950 ml-[1px] text-[12px] mt-auto h-[24px] md:h-auto w-[140px] md:w-[169px]'/></div>
            {searchSymbolTxt.length>0!=''?<div className='h-[190px] md:h-[70px] overflow-auto absolute z-[3] bg-white border border-gray-800 ml-[13px] w-full md:w-[169px] mt-[32px]'>{searchSymbolResult.map(x=><div className='hover:bg-gray-100 cursor-default text-[9px]' onClick={()=>onClick2Stock1(x)}>{x.symbol} {x.name}<br/></div>)}</div>:''}
            </div>
            <div className='flex md:mt-[4px]'>
            <div className='flex-col mr-[2px] relative'>
            <div className='font-bold text-[9px] leading-[1]'>industry ({industryList2.length})</div>
            <div className='h-[24px] md:h-auto flex border border-gray-800 bg-white w-full md:w-[120px] justify-between pl-[2px] text-[9px]' onClick={()=>setSelectMenu1(!selectMenu1)}>{selectedIndustry==''?<div className='w-fit m-auto text-[12px]'>-</div>:<div className='w-[80px] mt-auto mb-auto'>{selectedIndustry}</div>}{!selectMenu1?<MdKeyboardArrowDown className='mt-auto mb-auto text-[16px]'/>:<MdKeyboardArrowUp className='mt-auto mb-auto text-[16px]'/>}</div>
            {!selectMenu1?'':<div className='h-[190px] overflow-auto absolute z-[2] bg-white border border-gray-800 top-[32px] w-[115px] md:w-[120px] text-[9px] pl-[2px]'>
            {industryList2.map(x=><div value={x} className='hover:bg-gray-100 cursor-default' onClick={()=>onClick2FilterIndustry(x)}>{x.industry} ({x.item.length})</div>)}</div>}</div><div className='flex-col relative'><div className='font-bold text-[9px] leading-[1]'>symbol ({filterIndustry.length})</div>
            <div className='h-[24px] md:h-auto flex border border-gray-800 bg-white w-full md:w-[60px] pl-[2px] justify-between text-[9px]' onClick={()=>setSelectMenu2(!selectMenu2)}>{selectedIndustry==''?<><div className='w-fit m-auto text-[12px]'>-</div>{!selectMenu2?<MdKeyboardArrowDown className='mt-auto mb-auto text-[16px]'/>:<MdKeyboardArrowUp className='mt-auto mb-auto text-[16px]'/>}</>:<div className='flex justify-between'><div className='w-[40px] mt-auto mb-auto'>{selectedStock1.symbol}</div><div className='w-fit mt-auto mb-auto'>{!selectMenu2?<MdKeyboardArrowDown className='mt-auto mb-auto text-[16px]'/>:<MdKeyboardArrowUp className='mt-auto mb-auto text-[16px]'/>}</div></div>}</div>
            {!selectMenu2?'':<div className='h-[190px] overflow-auto absolute z-[2] bg-white border border-gray-800 right-[0px] md:right-[-140px] top-[32px] w-[200px] md:w-[200px]'>{filterIndustry.map(x=><div className='hover:bg-gray-100 cursor-default text-[9px] flex justify-between pr-[2px]' onClick={()=>onClick2Stock2(x)}><div className='pl-[2px]'>{x.symbol} {x.name}</div></div>)}</div>}  
            </div>
                </div>
                </div>
                <div className='md:w-[250px] flex justify-between'>
                <div className='w-auto md:w-[240px]'>
                <div className='font-light text-[20px]'>{selectedStock1==''?'select stock':<a target='_blank' href={`https://www.google.com/finance/quote/NVDA${selectedStock1.symbol}:NASDAQ?hl=en`}>{selectedStock1.name}</a>}</div>
                <div className='text-[9px] grid grid-cols-[140px_70px]'><div>Rate on {stock_graph1[selectedStocki1].items3M[6].name}:</div> <div>Return {selectedTerm}/td:</div></div><h2 className='grid grid-cols-[140px_70px]'>
                US${stock_graph1[selectedStocki1].items3M[6].price.toFixed(2)} {selectedStock1[`items${selectedTerm}`].map(x=>x.price)[6]/selectedStock1[`items${selectedTerm}`].map(x=>x.price)[0]-1>0?<div className='flex text-[#2e4665]'>+{Math.round((selectedStock1[`items${selectedTerm}`].map(x=>x.price)[6]/selectedStock1[`items${selectedTerm}`].map(x=>x.price)[0]-1)*100)}%<FaArrowUp className='m-auto'/></div>:<div className='flex text-[#6a272a]'>-{Math.round((1-(selectedStock1[`items${selectedTerm}`].map(x=>x.price)[6]/selectedStock1[`items${selectedTerm}`].map(x=>x.price)[0]))*100)}%<FaArrowDown className='m-auto'/></div>}
                </h2>
                <div className='grid grid-cols-[100px_80px] gap-[24px] mt-[8px]'>
                <div className='grid grid-cols-fit text-[9px]'>
                <div className='flex'>
                <div className='w-[54px]'>{selectedMarket=='nsdq'?<>NASDAQ</>:<>NYSE</>}:<br/>industry:</div>
                <div>{selectedStock1.symbol}<br/>{selectedStock1.industry}</div>
                </div>
                </div>
                <div className='grid grid-cols-fit text-[9px]'>
                <div className='flex'>
                <div className='w-[54px]'> employee:<br/>founded:</div>
                <div>{selectedStock1.employee.toLocaleString()}<br />{selectedStock1.founded}</div> 
                </div>
                </div>
                </div>
                <div className='grid grid-cols-[100px_60px] gap-[24px]'>
                <div className='grid grid-cols-fit text-[9px]'>
                <div className='flex mb-[8px]'>
                <div className='w-[54px]'>market cap:<br/>annual profit:<br/>annual revenue:</div>
                <div>{selectedStock1.market_cap}<br/>{selectedStock1.net_income}<br/>{selectedStock1.revenue}</div>
                </div>
                </div>
                <div className='grid grid-cols-fit text-[9px]'>
                <div className='flex'>
                <div className='w-[54px]'>asset:<br/>equity:</div>
                <div>{selectedStock1.asset}<br />{selectedStock1.equity}</div>
                </div>
                </div>
                </div>
                {selectedStock1.risk.length>0?
                <div className='grid grid-cols-[140px_100px] gap-[1px] text-[9px]'>
                <div>audit risk:<br/>board risk:<br/>compensation risk:<br/>shareholder rights risk:<br/>overall risk:</div>
                <div className='text-right'><div className='flex mt-[2px] mb-[4px]'>{(star(selectedStock1.risk[0]['audit risk'])).map(x=>(<><HiStar className='text-[#606277]'/></>))}</div><div className='flex mt-[2px] mb-[4px]'>{(star(selectedStock1.risk[1]['board risk'])).map(x=>(<><HiStar className='text-[#606277]' /></>))}</div><div className='flex mt-[2px] mb-[4px]'>{(star(selectedStock1.risk[2]['compensation risk'])).map(x=>(<><HiStar className='text-[#606277]'/></>))}</div><div className='flex mt-[2px] mb-[4px]'>{(star(selectedStock1.risk[3]['shareholder rights risk'])).map(x=>(<><HiStar className='text-[#606277]'/></>))}</div><div className='flex mt-[2px] mb-[4px]'>{(star(selectedStock1.risk[4]['overall risk'])).map(x=>(<><HiStar className='text-[#606277]'/></>))}</div><div className='flex mt-[2px] mb-[4px]'>{(star(selectedStock1.risk[5])).map(x=>(<><HiStar className='text-[#606277]'/></>))}</div></div>
                </div>
            :''}
                <div className='text-[9px]'>website: <a className='cursor-default hover:underline' href={selectedStock1.website} target='_blank'>{selectedStock1.website}</a></div>
                </div>
                <div className='md:w-[10px]'><div className='flex-col'><MdKeyboardArrowUp className={`${filterIndustry[0]._id==selectedStock1._id?'text-gray-300':'text-gray-800 hover:bg-gray-200'}`} onClick={onClick2StockUp}/><MdKeyboardArrowDown  className={`${filterIndustry.length-1==filterIndustry.findIndex((x)=>x._id==selectedStock1._id)?'text-gray-300':'text-gray-800 hover:bg-gray-200'}`} onClick={onClick2StockDown}/></div></div>
                </div>
                </div>
                <div className='sample-table-container-006'>
                <div className='ml-auto rate-tab flex w-fit md:block hidden'>{market.map((x, i) => (<button key={i} onClick={(e)=>onClick2Market(e,x.name)} className={`${selectedMarket === x.name ? 'underline text-gray-800' : undefined}`}
                >{x.name}</button>))}</div>
                <div className='rate-tab flex w-fit m-auto'>{graph_term.map((x, i) => (<button key={i} onClick={(e) => onClick2Term(e, x.term)} className={`${selectedTerm === x.term ? 'underline text-gray-800' : undefined}`}
                >{x.term}</button>))}</div>
                <div className='graph-container'>
                {graph_term.map((x, i)=>x.term==selectedTerm && <div className='hidden' key={i}>{x.data}</div>)}
                <LineChart className='line-graph-pc' width={500} height={200}>
                <CartesianGrid vertical={false} stroke="#f5f5f5" />
                <XAxis dataKey="name" type="category" allowDuplicatedCategory={false} />
                <YAxis dataKey="price" type="number" tickCount="9" allowDataOverflow domain={[0, Math.round(Math.max(...selectedStock1[`items${selectedTerm}`].map(x=>Number(x.price))))+100]}/>
                <Tooltip content={<HoverLabel />}/>
                <Line dataKey="price" data={selectedStock1[`items${selectedTerm}`]} type="linear" 
                stroke={selectedTerm=='pred'?'#bcbcbc':'#000'} strokeDasharray={selectedTerm=='pred'?'1.5':'0'} />
                {selectedTerm=='pred'?<Line dataKey="price" data={selectedStock1['itemspred2'].filter((x,i)=>i<5)} type="price" stroke="#000"/>:''}
                </LineChart>
                <ResponsiveContainer width="100%" height="100%">
                <LineChart className='line-graph-sp' width={250} height={100}>
                <CartesianGrid vertical={false} stroke="#f5f5f5" />
                <XAxis dataKey="name" type="category" allowDuplicatedCategory={false} />
                <YAxis dataKey="price" type="number" allowDataOverflow tickCount="9" domain={[0, Math.round(Math.max(...selectedStock1[`items${selectedTerm}`].map(x=>Number(x.price))))+100]}/>
                <Tooltip content={<HoverLabel />}/>
                <Line dataKey="price" data={selectedStock1[`items${selectedTerm}`]} type="linear" 
                stroke={selectedTerm=='pred'?'#bcbcbc':'#000'} strokeDasharray={selectedTerm=='pred'?'1.5':'0'} />
                {selectedTerm=='pred'?<Line dataKey="price" data={selectedStock1['itemspred2'].filter((x,i)=>i<5)} type="price" stroke="#000"/>:''}
                </LineChart>
                </ResponsiveContainer>
                </div>
                </div>
            </div>   
            <div className='md:max-w-[800px] md:m-auto'>
            <div className='hover:text-gray-600 border-b border-gray-400 w-fit cursor-default text-[9px] font-normal text-gray-800 flex' onClick={()=>onClick2SelectMenu(3)}> Machine Learning Prediction Accuracy Level {selectMenu3?<MdKeyboardArrowDown className='mt-[2px]'/>:<MdKeyboardArrowRight className='mt-[2px]'/>}</div>
            {selectMenu3? <div className='mt-[4px] text-[9px] text-[#000]'>
            <div className='font-bold'>Machine Learning 6m Return Future Prediction(pred 102025-032026)</div>
            <img className='mt-[4px] h-[60px]' src={RegressionImg}/>
            <div className='mt-[4px] font-bold'>Nasdaq</div>
            <div className='flex-col'>
                <div className='grid grid-cols-[250px] md:grid-cols-[250px_auto]'>    
                <div>
                <div className='font-bold'>index 100 dataset</div>
                <div className='flex'>
                <div className='border-t-[.01em] border-l-[.01em] border-r-[.01em] border-gray-400 w-[90px]'>
                <div className='h-[22.2px] pr-[8px] pl-[4px] border-b-[.01em] border-gray-400'>regression type</div>
                <div className='pl-[4px] border-b-[.01em] border-gray-400 flex justify-between'>vsd tree<HiStar className='mt-auto mb-auto text-[#606277]'/></div>
                <div className='pl-[4px] border-b-[.01em] border-gray-400'>linear pred</div>
                <div className='pl-[4px] border-b-[.01em] border-gray-400'>polinomial</div>
                <div className='pl-[4px] border-b-[.01em] border-gray-400'>svr rbf</div>
                </div>
                <div className='border-t-[.01em] border-r-[.01em] border-gray-400'>
                <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div>accuracy level</div><div className='flex text-[6px] font-bold text-right'><div className='w-[34px]'>500 items</div><div className='w-[48px]'>5,000 items</div><div className='w-[48px]'>50,000 items</div></div></div>
                <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400 flex'><div className='flex text-[9px] text-right'><div className='w-[34px]'>8.00%</div><div className='w-[48px]'>16.16%</div><div className='w-[48px] text-center'>70.00%</div></div></div>
                <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>7.00%</div><div className='w-[48px]'>11.11%</div><div className='w-[48px] text-center'>10.00%</div></div></div>
                <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>5.00%</div><div className='w-[48px]'>9.09%</div><div className='w-[48px] text-center'>10.00%</div></div></div>
                <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>10.00%</div><div className='w-[48px]'>7.07%</div><div className='w-[48px] text-center'>7.00%</div></div></div>
                </div>
                </div>
                </div>
                <div>
                <div className='mt-auto h-fit font-bold'>all stocks(3,373) dataset</div>
                <div className='flex'>
                    <div className='border-l-[.01em] border-t-[.01em] border-r-[.01em] border-gray-400 w-[90px]'>
                        <div className='h-[22.2px] pl-[4px] border-b-[.01em] border-gray-400'>regression type</div>
                        <div className='pl-[4px] pr-[8px] border-b-[.01em] border-gray-400 flex justify-between'>svr rbf<HiStar className='mt-auto mb-auto text-[#606277]'/></div>
                        <div className='pl-[4px] border-b-[.01em] border-gray-400'>polinomial</div>
                        <div className='pl-[4px] border-b-[.01em] border-gray-400'>vsd tree</div>
                        <div className='pl-[4px] border-b-[.01em] border-gray-400'>linear pred</div>
                    </div>
                    <div className=' border-t-[.01em] border-r-[.01em] border-gray-400'>
                        <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div>accuracy level</div><div className='flex text-[6px] font-bold text-right'><div className='w-[34px]'>500 items</div><div className='w-[48px]'>5,000 items</div><div className='w-[48px]'>50,000 items</div></div></div>
                        <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400 flex'><div className='flex text-[9px] text-right'><div className='w-[34px]'>12.60%</div><div className='w-[48px]'>12.37%</div><div className='w-[48px] text-center'>11.52%</div></div></div>
                        <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>5.28%</div><div className='w-[48px]'>10.96%</div><div className='w-[48px] text-center'>7.51%</div></div></div>
                        <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>11.35%</div><div className='w-[48px]'>10.83%</div><div className='w-[48px] text-center'>12.40%</div></div></div>
                        <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>9.22%</div><div className='w-[48px]'>10.76%</div><div className='w-[48px] text-center'>6.10%</div></div></div>
                    </div>
                </div>
                </div>
                </div>
                <div className='mt-[8px] font-bold'>NYSE</div>
                <div className='grid grid-cols-[250px] md:grid-cols-[250px_auto]'>
                <div>
                <div className='font-bold'>index 100 dataset</div>
                <div className='flex'>
                <div className='border-t-[.01em] border-l-[.01em] border-r-[.01em] border-gray-400 w-[90px]'>
                    <div className='h-[22.2px] pl-[4px] border-b-[.01em] border-gray-400 '>regression type</div>
                    <div className='pl-[4px] border-b-[.01em] border-gray-400'>vsd tree</div>
                    <div className='pl-[4px] border-b-[.01em] border-gray-400'>linear pred</div>
                    <div className='pl-[4px] pr-[8px] border-b-[.01em] border-gray-400 flex justify-between'>polinomial<HiStar className='mt-auto mb-auto text-[#606277]'/></div>
                    <div className='pl-[4px] border-b-[.01em] border-gray-400'>svr rbf</div>
                </div>
                <div className='border-t-[.01em] border-r-[.01em] border-gray-400'>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div>accuracy level</div><div className='flex text-[6px] font-bold text-right'><div className='w-[34px]'>500 items</div><div className='w-[48px]'>5,000 items</div><div className='w-[48px]'>50,000 items</div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>15.31%</div><div className='w-[48px]'>15.31%</div><div className='w-[48px] text-center'>67.35%</div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>19.39</div><div className='w-[48px]'>14.29%</div><div className='w-[48px] text-center'>14.29%</div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400 flex'><div className='flex text-[9px] text-right'><div className='w-[34px]'>9.18%</div><div className='w-[48px]'>20.41%</div><div className='w-[48px] text-center'>66.33%</div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>17.35%</div><div className='w-[48px]'>16.33%</div><div className='w-[48px] text-center'>19.39%</div></div></div>
                </div>
                </div>
                </div>
                <div>
                <div className='mt-auto font-bold'>all stocks(1,925) dataset</div>
                <div className='flex'>
                <div className='border-t-[.01em] border-l-[.01em] border-r-[.01em] border-gray-400 w-[90px]'>
                    <div className='h-[22.2px] pl-[4px] border-b-[.01em] border-gray-400'>regression type</div>
                    <div className='pl-[4px] border-b-[.01em] border-gray-400'>svr rbf</div>
                    <div className='pl-[4px] pr-[8px] border-b-[.01em] border-gray-400 flex justify-between'>polinomial<HiStar className='mt-auto mb-auto text-[#606277]'/></div>
                    <div className='pl-[4px] border-b-[.01em] border-gray-400'>vsd tree</div>
                    <div className='pl-[4px] border-b-[.01em] border-gray-400'>linear pred</div>
                </div>
                <div className='border-t-[.01em] border-r-[.01em] border-gray-400'>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div>accuracy level</div><div className='flex text-[6px] font-bold text-right'><div className='w-[34px]'>500 items</div><div className='w-[48px]'>5,000 items</div><div className='w-[48px]'>50,000 items</div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>17.65%</div><div className='w-[48px]'>17.28%</div><div className='w-[48px] text-center'>17.02% </div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400 flex'><div className='flex text-[9px] text-right'><div className='w-[34px]'>9.39%</div><div className='w-[48px]'>18.35%</div><div className='w-[48px] text-center'>15.95%</div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>15.64%</div><div className='w-[48px]'>17.15%</div><div className='w-[48px] text-center'>19.23%</div></div></div>
                    <div className='pl-[4px] pr-[4px] border-b-[.01em] border-gray-400'><div className='flex text-[9px] text-right'><div className='w-[34px]'>17.09%</div><div className='w-[48px]'>15.31%</div><div className='w-[48px] text-center'>15.95%</div></div></div>
                </div>
                </div>
                </div>
                
                </div>
            </div>
            </div>:''}
            <div className='mt-[2px] hover:text-gray-600 border-b border-gray-400 w-fit  cursor-default text-[9px] font-normal text-gray-800 flex' onClick={()=>onClick2SelectMenu(4)}>Trade Computing Report{selectMenu4?<MdKeyboardArrowDown className='mt-[2px]'/>:<MdKeyboardArrowRight className='mt-[2px]'/>}</div>
            {selectMenu4?<>
            <div className='grid grid-cols-2'>
            <div className='relative'>
            <div className='mt-[8px] text-gray-800 bg-[#f9f9f9] rounded-[12px] text-[8px] w-[250px] pt-[12px] pb-[12px] pl-[32px] pr-[32px]'><div className='mt-[16px] flex justify-between'><div className='font-bold mb-[8px] cursor-default w-fit' onClick={onClick2MainPage}>Stock Notify min & max</div>
            <div className='flex justify-between w-[60px] ml-[4px]'><div className={`underline mr-[4px] cursor-default ${page=='registerpage'?'font-bold':'guestpage'}`} onClick={onClick2SignUpPage}  onMouseEnter={()=>setToolTip(!toolTip)} onMouseLeave={()=>setToolTip(!toolTip)}>Sign up</div><div className={`underline cursor-default ${page=='userpage'?'font-bold':''}`} onClick={onClick2LoginPage}>Login</div></div>
            </div>
            <div className={`${toolTip?'inherit':'hidden'} cursor-default absolute left-[160px] top-[46px] bg-gray-100 border-[.2px] border-gray-800 pl-[2px] pr-[2px] text-[6px] w-fit`}>Create account to send notification</div>
            {page==='registerpage'?<>{optionTabs[0].table}</>:''}
            {page==='loginpage'?<>{optionTabs[1].table}</>:''}
            {page==='mainpage'?<>{account_token?<>{optionTabs[3].table}</>:<>{optionTabs[2].table}</>}</>:''}

            </div>
            </div>
            <div className='text-gray-800'>
                <div className='mb-[8px]'>Send Notification History(Sample)</div>
                <div className='grid grid-cols-[60px_120px]'>
                <h2 className='text-[18px] leading-[.9em] ml-[2px]'>{stockAccount2.notification_history.length}<br/><span className='text-[9px]'>times</span></h2>
                <div className='flex flex-col'>{stockAccount2.notification_history.map(x=><div>{x.date} {x.return>0?<>+US${x.return}</>:<>-US${x.return*-1}</>}</div>)}
                </div>
                </div>
            </div>
            </div>
            </>
        :''}
            <div className='mt-[2px] hover:text-gray-600 border-b border-gray-400 w-fit  cursor-default text-[9px] font-normal text-gray-800 flex' onClick={()=>onClick2SelectMenu(5)}>Quick Link{selectMenu5?<MdKeyboardArrowDown className='mt-[2px]'/>:<MdKeyboardArrowRight className='mt-[2px]'/>}</div>
            {selectMenu5? <>
            <div className='flex flex-col md:flex-row w-auto text-gray-800 font-bold text-[9px]'>
            <div className='mr-[10px] mt-[8px] text-[16px] md:text-[12px] md:mt-auto'>Quick Link</div>
            <div className='md:ml-auto w-fit flex mr-[10px]'>{selectedStock1.symbol}x <IoTicketOutline className='mt-[2px]'/>{Math.floor(amount1/stock_graph1[selectedStocki1].itemsbox[term].price.toFixed(2))}</div>
            <div className='flex mr-[10px]'><div className='w-[40px] md:w-[36px]'>Bit<br/>Return:</div><div>US$<input className='border border-gray-800 w-[40px] text-right' type='text' value={amount1} onChange={onChange2Amount1}/><br/><div className='flex justify-between'><div>US$</div><div>{(((stock_graph1[selectedStocki1].items3M[6].price.toFixed(2)*Math.floor(10000/stock_graph1[selectedStocki1].itemsbox[term].price.toFixed(2))).toFixed(2))-(stock_graph1[selectedStocki1].itemsbox[term].price.toFixed(2)*Math.floor(10000/stock_graph1[selectedStocki1].itemsbox[term].price.toFixed(2)))).toFixed(2)}</div></div></div></div>
            <div className='flex mr-[10px]'><div className='w-[40px] md:w-[20px]'>In:<br/>Out:</div><div>{(stock_graph1[selectedStocki1].itemsbox[term].price.toFixed(2)*Math.floor(10000/stock_graph1[selectedStocki1].itemsbox[term].price.toFixed(2))).toFixed(2)}<br/>{(stock_graph1[selectedStocki1].items3M[6].price.toFixed(2)*Math.floor(10000/stock_graph1[selectedStocki1].itemsbox[term].price.toFixed(2))).toFixed(2)}</div></div>
            <div className='w-full md:w-[120px] text-[9px] flex-col'><div className='w-full md:w-[60px] mt-auto'>
            <input type='range' name='text1' min='0' max={selectedStock1['itemsbox'].length-1} step='1' value={term} onChange={onChange2Term} className='slider'/>
            </div><div>{stock_graph1[selectedStocki1].itemsbox[term].name} - {stock_graph1[selectedStocki1].items3M[6].name}({(selectedStock1['itemsbox'].map(x=>x.label))[term]})</div></div>
            </div>
            <div className='flex-col md:flex justify-between'>
            <div className='mt-[10px] md:mt-[0px] col-span-4 text-[9px] text-gray-800 font-bold'>     
            <button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='return'?'bg-gray-400':'bg-gray-100'}`} onClick={x=>onClick2Type('return')}>return</button>
            {selectedMarket=='nsdq'?<button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='risk'?'bg-gray-400':'bg-gray-100'}`} onClick={x=>onClick2Type('risk')}>risk</button>:''}<button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='market cap'?'bg-gray-400':'bg-gray-100'}`} onClick={x=>onClick2Type('market cap')}>market cap</button>
            <button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='net income'?'bg-gray-400':'bg-gray-100'}`} onClick={x=>onClick2Type('net income')}>annual profit</button><button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='revenue'?'bg-gray-400':'bg-gray-100'}`} onClick={x=>onClick2Type('revenue')}>annual revenue</button><button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='employee'?'bg-gray-200':'bg-gray-100'}`} onClick={x=>onClick2Type('employee')}>employee</button><button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='founded year (old)'?'bg-gray-200':'bg-gray-100'}`} onClick={x=>onClick2Type('founded year (old)')}>traditional company</button><button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='founded year (new)'?'bg-gray-200':'bg-gray-100'}`} onClick={x=>onClick2Type('founded year (new)')}>startups</button>
            <button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='asset'?'bg-gray-400':'bg-gray-100'}`} onClick={x=>onClick2Type('asset')}>asset</button>
            <button className={`mb-[1px] mr-[2px] pl-[4px] pr-[4px] hover:bg-gray-300 rounded-sm ${type=='equity'?'bg-gray-400':'bg-gray-100'}`} onClick={x=>onClick2Type('equity')}>equity</button>
            </div>
            <div className='mt-[10px] md:mt-[0px] text-[9px] text-gray-800 font-bold flex'><span className='mt-auto mb-auto mr-[2px]'>limit:</span> <input type='radio' checked={selectedLimit=='catg 10'} onChange={()=>onClick2SelectMenu('catg 10')}/> <span className='mt-auto mb-auto ml-[2px] mr-[2px]'>top10</span><input type='radio' checked={selectedLimit=='catg all'} onChange={()=>onClick2SelectMenu('catg all')}/> <span className=' ml-[2px] mr-[2px] mt-auto mb-auto'>group all</span><input type='radio' checked={selectedLimit==='all'} onChange={()=>onClick2SelectMenu('all')}/> <span className='ml-[2px] mt-auto mb-auto'>all</span></div>
            </div>
            {selectedLimit=='all'?<div className='mt-[10px] md:mt-[0px] text-gray-800 font-bold text-[9px] w-fit grid grid-cols-4 gap-[4px]'><Treemap2 data={data2_2(reorder_return2(reorder_market_cap2(stock_graph1)))}/></div>:''}
            <div className='mt-[10px] md:mt-[0px] text-gray-800 font-bold text-[9px] w-full md:w-fit grid grid-cols-1 md:grid-cols-4 gap-[4px]'>
            {selectedLimit=='catg 10'?<>{reorder_market_cap(industryList2).slice(0,12).map(x1=><div className='inherit md:inline-block'><div className='text-blue-80 font-bold'>{x1.industry}</div><Treemap1 data={data2_2(reorder_return(x1.industry,x1.item).slice(0,10))}/></div>)}</>:''}
            {selectedLimit=='catg all'?<>{reorder_market_cap(industryList2).slice(0,12).map(x1=><div className='inherit md:inline-block'><div className='text-blue-80 font-bold'>{x1.industry}</div><Treemap1 data={data2_2(reorder_return(x1.industry,x1.item))}/></div>)}</>:''}
    {/*         
        {selectedLimit=='catg 10'?<>{reorder_market_cap(industryList2).map(x1=><div>
                <div className='text-blue-80 font-bold'>{x1.industry}
                </div>
                <div className='grid grid-cols-3 w-auto text-[9px]'>
                {reorder_return(x1.industry,x1.item).map(x2=><div className={`card1 cursor-default m-[.4px] pl-[4px] pr-[4px] pt-[6px] text-white order border-gray-800 ${Number(x2.return.replace('%','').replace('+',''))>0?'bg-[#2e4665] hover:bg-[#2e4665]/90':'bg-[#6a272a] hover:bg-[#6a272a]/90'}`} onClick={x=>onClick2Stock3(x2)}>    
                <div className='text-[6px] leading-[6px] mb-[4px]'>{x2.name}</div><div className='leading-[6px] mb-[2px]'>{x2.symbol}</div><div className='font-light text-right'>
                {x2.return}<br/>
                {x2.value}<br/>
                {type=='risk'?<>{x2.risk[4]['overall risk']}</>:''}
                {type=='market cap'?<>{x2.market_cap}</>:''}
                {type=='net income'?<>{x2.net_income}</>:''}
                {type=='revenue'?<>{x2.revenue}</>:''}
                {type=='employee'?<>{x2.employee}</>:''}
                {type=='founded year (old)'||type=='founded year (new)'?<>{x2.founded}</>:''}
                {type=='asset'?<>{x2.asset}</>:''}
                {type=='equity'?<>{x2.equity}</>:''}</div></div>).slice(0,10)}</div>
            </div>)}</>:<>{reorder_market_cap(industryList2).map(x1=><div>
            <div className='text-blue-80 font-bold'>{x1.industry}
            </div>
            <div className='grid grid-cols-3 w-auto text-[9px]'>
            {reorder_return(x1.industry,x1.item).map(x2=><div className={`card1 cursor-default m-[.4px] pl-[4px] pr-[4px] pt-[6px] text-white order border-gray-800 ${Number(x2.return.replace('%','').replace('+',''))>0?'bg-[#2e4665] hover:bg-[#2e4665]/90':'bg-[#6a272a] hover:bg-[#6a272a]/90'}`} onClick={x=>onClick2Stock3(x2)}>    
            <div className='text-[6px] leading-[6px] mb-[4px]'>{x2.name}</div><div className='leading-[6px] mb-[2px]'>{x2.symbol}</div><div className='font-light text-right'>
            {x2.return}<br/>
            {x2.value}<br/>
                {type=='risk'?<>{x2.risk[4]['overall risk']}</>:''}
                {type=='market cap'?<>{x2.market_cap}</>:''}
                {type=='net income'?<>{x2.net_income}</>:''}
                {type=='revenue'?<>{x2.revenue}</>:''}
                {type=='employee'?<>{x2.employee}</>:''}
                {type=='founded year (old)'||type=='founded year (new)'?<>{x2.founded}</>:''}
                {type=='asset'?<>{x2.asset}</>:''}
                {type=='equity'?<>{x2.equity}</>:''}
                </div>            
                </div>)}</div>
                </div>)}</>} */}
            </div>
            </>:''}
            <button className='bg-gray-800 hover:bg-gray-500 text-[9px] text-white mr-[4px] pr-[4px] pl-[4px]' onClick={onClick2ManualUpdate}>manual update to the latest data</button>{msg}
            </div>
            </>}
            </StyledContainer >
    )
}
